export const newContactClubFields = {
  firstname: {
    fieldPath: 'firstname',
    errorFieldPath: 'firstname',
    fieldReadPath: 'firstname',
    name: 'firstname',
    label: 'contacts.contacts.contact_individual.firstname.label',
    id: 'contacts-contacts__firstname',
    veeValidation: true,
    rules: ['required', 'string'],
    warningRules: [],
    fieldClass: 'contacts-contacts__firstname--input',
    showError: true,
    errorClass: 'contacts-contacts__firstname--input-error',
    errorAttributes: [],
    showHelp: false,
    helpClass: 'contacts-contacts__firstname--input-help',
    helpAttributes: [],
    help: 'contacts.contacts.firstname.help',
    showFeedback: true,
    feedbackClass: 'contacts-contacts__firstname--input-feedback',
    feedbackAttributes: [],
    feedback: 'contacts.contacts.firstname.feedback',
    showLabel: true,
    labelClass: 'contacts-contacts__firstname--input-label',
    labelAttributes: {
      for: 'contacts-contacts__firstname',
    },
  },
  lastname: {
    fieldPath: 'lastname',
    errorFieldPath: 'lastname',
    fieldReadPath: 'lastname',
    name: 'lastname',
    label: 'contacts.contacts.contact_individual.lastname.label',
    id: 'contacts-contacts__lastname',
    veeValidation: true,
    rules: ['required', 'string'],
    warningRules: [],
    fieldClass: 'contacts-contacts__lastname--input',
    showError: true,
    errorClass: 'contacts-contacts__lastname--input-error',
    errorAttributes: [],
    showHelp: false,
    helpClass: 'contacts-contacts__lastname--input-help',
    helpAttributes: [],
    help: 'contacts.contacts.lastname.help',
    showFeedback: true,
    feedbackClass: 'contacts-contacts__lastname--input-feedback',
    feedbackAttributes: [],
    feedback: 'contacts.contacts.lastname.feedback',
    showLabel: true,
    labelClass: 'contacts-contacts__lastname--input-label',
    labelAttributes: {
      for: 'contacts-contacts__lastname',
    },
  },
  birthdate: {
    fieldPath: 'birthdate',
    errorFieldPath: 'birthdate',
    fieldReadPath: 'birthdate',
    name: 'birthdate',
    label: 'contacts.contacts.contact_individual.birthdate.label',
    id: 'contacts-contacts__birthdate',
    veeValidation: true,
    rules: ['required'],
    warningRules: [],
    fieldClass: 'contacts-contacts__birthdate--input',
    showError: true,
    errorClass: 'contacts-contacts__birthdate--input-error',
    errorAttributes: [],
    showHelp: false,
    helpClass: 'contacts-contacts__birthdate--input-help',
    helpAttributes: [],
    help: 'contacts.contacts.birthdate.help',
    showFeedback: true,
    feedbackClass: 'contacts-contacts__birthdate--input-feedback',
    feedbackAttributes: [],
    feedback: 'contacts.contacts.birthdate.feedback',
    showLabel: true,
    labelClass: 'contacts-contacts__birthdate--input-label',
    labelAttributes: {
      for: 'contacts-contacts__birthdate',
    },
  },
  gender: {
    fieldPath: 'gender',
    errorFieldPath: 'gender',
    fieldReadPath: 'gender',
    name: 'gender',
    label: 'contacts.contacts.contact_individual.gender.label',
    options: [
      {
        text: 'global.contact_individual.gender.placeholder',
        value: null,
      },
      {
        text: 'global.contact_individual.man',
        value: 'M',
      },
      {
        text: 'global.contact_individual.woman',
        value: 'W',
      },
      {
        text: 'global.contact_individual.na',
        value: '-',
      },
    ],
    id: 'contacts-contacts__gender',
    veeValidation: true,
    rules: ['required_if_show_mandatory:show_new_contact_gender'],
    warningRules: [],
    fieldClass: 'contacts-contacts__gender--input',
    showError: true,
    errorClass: 'contacts-contacts__gender--input-error',
    errorAttributes: [],
    showHelp: false,
    helpClass: 'contacts-contacts__gender--input-help',
    helpAttributes: [],
    help: 'contacts.contacts.gender.help',
    showFeedback: true,
    feedbackClass: 'contacts-contacts__gender--input-feedback',
    feedbackAttributes: [],
    feedback: 'contacts.contacts.gender.feedback',
    showLabel: true,
    labelClass: 'contacts-contacts__gender--input-label',
    labelAttributes: {
      for: 'contacts-contacts__gender',
    },
  },
  street: {
    fieldPath: 'street',
    errorFieldPath: 'street',
    fieldReadPath: 'street',
    name: 'street',
    label: 'contacts.contacts.contact_detail.street.label',
    id: 'contacts-contacts__street',
    veeValidation: true,
    rules: ['required_if_show_mandatory:show_new_contact_address_fields'],
    warningRules: [],
    fieldClass: 'contacts-contacts__street--input',
    showError: true,
    errorClass: 'contacts-contacts__street--input-error',
    errorAttributes: [],
    showHelp: false,
    helpClass: 'contacts-contacts__street--input-help',
    helpAttributes: [],
    help: 'contacts.contacts.street.help',
    showFeedback: true,
    feedbackClass: 'contacts-contacts__street--input-feedback',
    feedbackAttributes: [],
    feedback: 'contacts.contacts.street.feedback',
    showLabel: true,
    labelClass: 'contacts-contacts__street--input-label',
    labelAttributes: {
      for: 'contacts-contacts__street',
    },
    placeholder: 'contacts.contacts.contact_detail.street.label',
  },
  street2: {
    fieldPath: 'street2',
    errorFieldPath: 'street2',
    fieldReadPath: 'street2',
    name: 'street2',
    label: 'ㅤ',
    id: 'contacts-contacts__street2',
    veeValidation: true,
    rules: ['nullable'],
    warningRules: [],
    fieldClass: 'contacts-contacts__street2--input',
    showError: true,
    errorClass: 'contacts-contacts__street2--input-error',
    errorAttributes: [],
    showHelp: false,
    helpClass: 'contacts-contacts__street2--input-help',
    helpAttributes: [],
    help: 'contacts.contacts.street2.help',
    showFeedback: true,
    feedbackClass: 'contacts-contacts__street2--input-feedback',
    feedbackAttributes: [],
    feedback: 'contacts.contacts.street2.feedback',
    showLabel: true,
    labelClass: 'contacts-contacts__street2--input-label',
    labelAttributes: {
      for: 'contacts-contacts__street2',
    },
    placeholder: 'contacts.contacts.contact_detail.street2.label',
  },
  zip: {
    fieldPath: 'zip',
    errorFieldPath: 'zip',
    fieldReadPath: 'zip',
    name: 'zip',
    label: '',
    id: 'contacts-contacts__zip',
    veeValidation: true,
    rules: ['required_if_show_mandatory:show_new_contact_address_fields'],
    warningRules: [],
    fieldClass: 'contacts-contacts__zip--input',
    showError: true,
    errorClass: 'contacts-contacts__zip--input-error',
    errorAttributes: [],
    showHelp: false,
    helpClass: 'contacts-contacts__zip--input-help',
    helpAttributes: [],
    help: 'contacts.contacts.zip.help',
    showFeedback: true,
    feedbackClass: 'contacts-contacts__zip--input-feedback',
    feedbackAttributes: [],
    feedback: 'contacts.contacts.zip.feedback',
    showLabel: true,
    labelClass: 'contacts-contacts__zip--input-label',
    labelAttributes: {
      for: 'contacts-contacts__zip',
    },
    placeholder: 'contacts.contacts.contact_detail.zip.label',
  },
  city: {
    fieldPath: 'city',
    errorFieldPath: 'city',
    fieldReadPath: 'city',
    name: 'city',
    label: '',
    id: 'contacts-contacts__city',
    veeValidation: true,
    rules: ['required_if_show_mandatory:show_new_contact_address_fields'],
    warningRules: [],
    fieldClass: 'contacts-contacts__city--input',
    showError: true,
    errorClass: 'contacts-contacts__city--input-error',
    errorAttributes: [],
    showHelp: false,
    helpClass: 'contacts-contacts__city--input-help',
    helpAttributes: [],
    help: 'contacts.contacts.city.help',
    showFeedback: true,
    feedbackClass: 'contacts-contacts__city--input-feedback',
    feedbackAttributes: [],
    feedback: 'contacts.contacts.city.feedback',
    showLabel: true,
    labelClass: 'contacts-contacts__city--input-label',
    labelAttributes: {
      for: 'contacts-contacts__city',
    },
    placeholder: 'contacts.contacts.contact_detail.city.label',
  },
  country: {
    fieldPath: 'country',
    errorFieldPath: 'country',
    fieldReadPath: 'country',
    name: 'country',
    label: '',
    options: [
      {
        text: 'countries.placeholder',
        value: 'null',
      },
      {
        text: 'countries.ad',
        value: 'ad',
      },
      {
        text: 'countries.ae',
        value: 'ae',
      },
      {
        text: 'countries.af',
        value: 'af',
      },
      {
        text: 'countries.ag',
        value: 'ag',
      },
      {
        text: 'countries.ai',
        value: 'ai',
      },
      {
        text: 'countries.al',
        value: 'al',
      },
      {
        text: 'countries.am',
        value: 'am',
      },
      {
        text: 'countries.ao',
        value: 'ao',
      },
      {
        text: 'countries.aq',
        value: 'aq',
      },
      {
        text: 'countries.ar',
        value: 'ar',
      },
      {
        text: 'countries.as',
        value: 'as',
      },
      {
        text: 'countries.at',
        value: 'at',
      },
      {
        text: 'countries.au',
        value: 'au',
      },
      {
        text: 'countries.aw',
        value: 'aw',
      },
      {
        text: 'countries.ax',
        value: 'ax',
      },
      {
        text: 'countries.az',
        value: 'az',
      },
      {
        text: 'countries.ba',
        value: 'ba',
      },
      {
        text: 'countries.bb',
        value: 'bb',
      },
      {
        text: 'countries.bd',
        value: 'bd',
      },
      {
        text: 'countries.be',
        value: 'be',
      },
      {
        text: 'countries.bf',
        value: 'bf',
      },
      {
        text: 'countries.bg',
        value: 'bg',
      },
      {
        text: 'countries.bh',
        value: 'bh',
      },
      {
        text: 'countries.bi',
        value: 'bi',
      },
      {
        text: 'countries.bj',
        value: 'bj',
      },
      {
        text: 'countries.bl',
        value: 'bl',
      },
      {
        text: 'countries.bm',
        value: 'bm',
      },
      {
        text: 'countries.bn',
        value: 'bn',
      },
      {
        text: 'countries.bo',
        value: 'bo',
      },
      {
        text: 'countries.bq',
        value: 'bq',
      },
      {
        text: 'countries.br',
        value: 'br',
      },
      {
        text: 'countries.bs',
        value: 'bs',
      },
      {
        text: 'countries.bt',
        value: 'bt',
      },
      {
        text: 'countries.bv',
        value: 'bv',
      },
      {
        text: 'countries.bw',
        value: 'bw',
      },
      {
        text: 'countries.by',
        value: 'by',
      },
      {
        text: 'countries.bz',
        value: 'bz',
      },
      {
        text: 'countries.ca',
        value: 'ca',
      },
      {
        text: 'countries.cc',
        value: 'cc',
      },
      {
        text: 'countries.cd',
        value: 'cd',
      },
      {
        text: 'countries.cf',
        value: 'cf',
      },
      {
        text: 'countries.cg',
        value: 'cg',
      },
      {
        text: 'countries.ch',
        value: 'ch',
      },
      {
        text: 'countries.ci',
        value: 'ci',
      },
      {
        text: 'countries.ck',
        value: 'ck',
      },
      {
        text: 'countries.cl',
        value: 'cl',
      },
      {
        text: 'countries.cm',
        value: 'cm',
      },
      {
        text: 'countries.cn',
        value: 'cn',
      },
      {
        text: 'countries.co',
        value: 'co',
      },
      {
        text: 'countries.cr',
        value: 'cr',
      },
      {
        text: 'countries.cu',
        value: 'cu',
      },
      {
        text: 'countries.cv',
        value: 'cv',
      },
      {
        text: 'countries.cw',
        value: 'cw',
      },
      {
        text: 'countries.cx',
        value: 'cx',
      },
      {
        text: 'countries.cy',
        value: 'cy',
      },
      {
        text: 'countries.cz',
        value: 'cz',
      },
      {
        text: 'countries.de',
        value: 'de',
      },
      {
        text: 'countries.dj',
        value: 'dj',
      },
      {
        text: 'countries.dk',
        value: 'dk',
      },
      {
        text: 'countries.dm',
        value: 'dm',
      },
      {
        text: 'countries.do',
        value: 'do',
      },
      {
        text: 'countries.dz',
        value: 'dz',
      },
      {
        text: 'countries.ec',
        value: 'ec',
      },
      {
        text: 'countries.ee',
        value: 'ee',
      },
      {
        text: 'countries.eg',
        value: 'eg',
      },
      {
        text: 'countries.eh',
        value: 'eh',
      },
      {
        text: 'countries.er',
        value: 'er',
      },
      {
        text: 'countries.es',
        value: 'es',
      },
      {
        text: 'countries.et',
        value: 'et',
      },
      {
        text: 'countries.fi',
        value: 'fi',
      },
      {
        text: 'countries.fj',
        value: 'fj',
      },
      {
        text: 'countries.fk',
        value: 'fk',
      },
      {
        text: 'countries.fm',
        value: 'fm',
      },
      {
        text: 'countries.fo',
        value: 'fo',
      },
      {
        text: 'countries.fr',
        value: 'fr',
      },
      {
        text: 'countries.ga',
        value: 'ga',
      },
      {
        text: 'countries.gb',
        value: 'gb',
      },
      {
        text: 'countries.gd',
        value: 'gd',
      },
      {
        text: 'countries.ge',
        value: 'ge',
      },
      {
        text: 'countries.gf',
        value: 'gf',
      },
      {
        text: 'countries.gg',
        value: 'gg',
      },
      {
        text: 'countries.gh',
        value: 'gh',
      },
      {
        text: 'countries.gi',
        value: 'gi',
      },
      {
        text: 'countries.gl',
        value: 'gl',
      },
      {
        text: 'countries.gm',
        value: 'gm',
      },
      {
        text: 'countries.gn',
        value: 'gn',
      },
      {
        text: 'countries.gp',
        value: 'gp',
      },
      {
        text: 'countries.gq',
        value: 'gq',
      },
      {
        text: 'countries.gr',
        value: 'gr',
      },
      {
        text: 'countries.gs',
        value: 'gs',
      },
      {
        text: 'countries.gt',
        value: 'gt',
      },
      {
        text: 'countries.gu',
        value: 'gu',
      },
      {
        text: 'countries.gw',
        value: 'gw',
      },
      {
        text: 'countries.gy',
        value: 'gy',
      },
      {
        text: 'countries.hk',
        value: 'hk',
      },
      {
        text: 'countries.hm',
        value: 'hm',
      },
      {
        text: 'countries.hn',
        value: 'hn',
      },
      {
        text: 'countries.hr',
        value: 'hr',
      },
      {
        text: 'countries.ht',
        value: 'ht',
      },
      {
        text: 'countries.hu',
        value: 'hu',
      },
      {
        text: 'countries.id',
        value: 'id',
      },
      {
        text: 'countries.ie',
        value: 'ie',
      },
      {
        text: 'countries.il',
        value: 'il',
      },
      {
        text: 'countries.im',
        value: 'im',
      },
      {
        text: 'countries.in',
        value: 'in',
      },
      {
        text: 'countries.io',
        value: 'io',
      },
      {
        text: 'countries.iq',
        value: 'iq',
      },
      {
        text: 'countries.ir',
        value: 'ir',
      },
      {
        text: 'countries.is',
        value: 'is',
      },
      {
        text: 'countries.it',
        value: 'it',
      },
      {
        text: 'countries.je',
        value: 'je',
      },
      {
        text: 'countries.jm',
        value: 'jm',
      },
      {
        text: 'countries.jo',
        value: 'jo',
      },
      {
        text: 'countries.jp',
        value: 'jp',
      },
      {
        text: 'countries.ke',
        value: 'ke',
      },
      {
        text: 'countries.kg',
        value: 'kg',
      },
      {
        text: 'countries.kh',
        value: 'kh',
      },
      {
        text: 'countries.ki',
        value: 'ki',
      },
      {
        text: 'countries.km',
        value: 'km',
      },
      {
        text: 'countries.kn',
        value: 'kn',
      },
      {
        text: 'countries.kp',
        value: 'kp',
      },
      {
        text: 'countries.kr',
        value: 'kr',
      },
      {
        text: 'countries.kw',
        value: 'kw',
      },
      {
        text: 'countries.ky',
        value: 'ky',
      },
      {
        text: 'countries.kz',
        value: 'kz',
      },
      {
        text: 'countries.la',
        value: 'la',
      },
      {
        text: 'countries.lb',
        value: 'lb',
      },
      {
        text: 'countries.lc',
        value: 'lc',
      },
      {
        text: 'countries.li',
        value: 'li',
      },
      {
        text: 'countries.lk',
        value: 'lk',
      },
      {
        text: 'countries.lr',
        value: 'lr',
      },
      {
        text: 'countries.ls',
        value: 'ls',
      },
      {
        text: 'countries.lt',
        value: 'lt',
      },
      {
        text: 'countries.lu',
        value: 'lu',
      },
      {
        text: 'countries.lv',
        value: 'lv',
      },
      {
        text: 'countries.ly',
        value: 'ly',
      },
      {
        text: 'countries.ma',
        value: 'ma',
      },
      {
        text: 'countries.mc',
        value: 'mc',
      },
      {
        text: 'countries.md',
        value: 'md',
      },
      {
        text: 'countries.me',
        value: 'me',
      },
      {
        text: 'countries.mf',
        value: 'mf',
      },
      {
        text: 'countries.mg',
        value: 'mg',
      },
      {
        text: 'countries.mh',
        value: 'mh',
      },
      {
        text: 'countries.mk',
        value: 'mk',
      },
      {
        text: 'countries.ml',
        value: 'ml',
      },
      {
        text: 'countries.mm',
        value: 'mm',
      },
      {
        text: 'countries.mn',
        value: 'mn',
      },
      {
        text: 'countries.mo',
        value: 'mo',
      },
      {
        text: 'countries.mp',
        value: 'mp',
      },
      {
        text: 'countries.mq',
        value: 'mq',
      },
      {
        text: 'countries.mr',
        value: 'mr',
      },
      {
        text: 'countries.ms',
        value: 'ms',
      },
      {
        text: 'countries.mt',
        value: 'mt',
      },
      {
        text: 'countries.mu',
        value: 'mu',
      },
      {
        text: 'countries.mv',
        value: 'mv',
      },
      {
        text: 'countries.mw',
        value: 'mw',
      },
      {
        text: 'countries.mx',
        value: 'mx',
      },
      {
        text: 'countries.my',
        value: 'my',
      },
      {
        text: 'countries.mz',
        value: 'mz',
      },
      {
        text: 'countries.na',
        value: 'na',
      },
      {
        text: 'countries.nc',
        value: 'nc',
      },
      {
        text: 'countries.ne',
        value: 'ne',
      },
      {
        text: 'countries.nf',
        value: 'nf',
      },
      {
        text: 'countries.ng',
        value: 'ng',
      },
      {
        text: 'countries.ni',
        value: 'ni',
      },
      {
        text: 'countries.nl',
        value: 'nl',
      },
      {
        text: 'countries.no',
        value: 'no',
      },
      {
        text: 'countries.np',
        value: 'np',
      },
      {
        text: 'countries.nr',
        value: 'nr',
      },
      {
        text: 'countries.nu',
        value: 'nu',
      },
      {
        text: 'countries.nz',
        value: 'nz',
      },
      {
        text: 'countries.om',
        value: 'om',
      },
      {
        text: 'countries.pa',
        value: 'pa',
      },
      {
        text: 'countries.pe',
        value: 'pe',
      },
      {
        text: 'countries.pf',
        value: 'pf',
      },
      {
        text: 'countries.pg',
        value: 'pg',
      },
      {
        text: 'countries.ph',
        value: 'ph',
      },
      {
        text: 'countries.pk',
        value: 'pk',
      },
      {
        text: 'countries.pl',
        value: 'pl',
      },
      {
        text: 'countries.pm',
        value: 'pm',
      },
      {
        text: 'countries.pn',
        value: 'pn',
      },
      {
        text: 'countries.pr',
        value: 'pr',
      },
      {
        text: 'countries.ps',
        value: 'ps',
      },
      {
        text: 'countries.pt',
        value: 'pt',
      },
      {
        text: 'countries.pw',
        value: 'pw',
      },
      {
        text: 'countries.py',
        value: 'py',
      },
      {
        text: 'countries.qa',
        value: 'qa',
      },
      {
        text: 'countries.re',
        value: 're',
      },
      {
        text: 'countries.ro',
        value: 'ro',
      },
      {
        text: 'countries.rs',
        value: 'rs',
      },
      {
        text: 'countries.ru',
        value: 'ru',
      },
      {
        text: 'countries.rw',
        value: 'rw',
      },
      {
        text: 'countries.sa',
        value: 'sa',
      },
      {
        text: 'countries.sb',
        value: 'sb',
      },
      {
        text: 'countries.sc',
        value: 'sc',
      },
      {
        text: 'countries.sd',
        value: 'sd',
      },
      {
        text: 'countries.se',
        value: 'se',
      },
      {
        text: 'countries.sg',
        value: 'sg',
      },
      {
        text: 'countries.sh',
        value: 'sh',
      },
      {
        text: 'countries.si',
        value: 'si',
      },
      {
        text: 'countries.sj',
        value: 'sj',
      },
      {
        text: 'countries.sk',
        value: 'sk',
      },
      {
        text: 'countries.sl',
        value: 'sl',
      },
      {
        text: 'countries.sm',
        value: 'sm',
      },
      {
        text: 'countries.sn',
        value: 'sn',
      },
      {
        text: 'countries.so',
        value: 'so',
      },
      {
        text: 'countries.sr',
        value: 'sr',
      },
      {
        text: 'countries.ss',
        value: 'ss',
      },
      {
        text: 'countries.st',
        value: 'st',
      },
      {
        text: 'countries.sv',
        value: 'sv',
      },
      {
        text: 'countries.sx',
        value: 'sx',
      },
      {
        text: 'countries.sy',
        value: 'sy',
      },
      {
        text: 'countries.sz',
        value: 'sz',
      },
      {
        text: 'countries.tc',
        value: 'tc',
      },
      {
        text: 'countries.td',
        value: 'td',
      },
      {
        text: 'countries.tf',
        value: 'tf',
      },
      {
        text: 'countries.tg',
        value: 'tg',
      },
      {
        text: 'countries.th',
        value: 'th',
      },
      {
        text: 'countries.tj',
        value: 'tj',
      },
      {
        text: 'countries.tk',
        value: 'tk',
      },
      {
        text: 'countries.tl',
        value: 'tl',
      },
      {
        text: 'countries.tm',
        value: 'tm',
      },
      {
        text: 'countries.tn',
        value: 'tn',
      },
      {
        text: 'countries.to',
        value: 'to',
      },
      {
        text: 'countries.tr',
        value: 'tr',
      },
      {
        text: 'countries.tt',
        value: 'tt',
      },
      {
        text: 'countries.tv',
        value: 'tv',
      },
      {
        text: 'countries.tw',
        value: 'tw',
      },
      {
        text: 'countries.tz',
        value: 'tz',
      },
      {
        text: 'countries.ua',
        value: 'ua',
      },
      {
        text: 'countries.ug',
        value: 'ug',
      },
      {
        text: 'countries.um',
        value: 'um',
      },
      {
        text: 'countries.us',
        value: 'us',
      },
      {
        text: 'countries.uy',
        value: 'uy',
      },
      {
        text: 'countries.uz',
        value: 'uz',
      },
      {
        text: 'countries.va',
        value: 'va',
      },
      {
        text: 'countries.vc',
        value: 'vc',
      },
      {
        text: 'countries.ve',
        value: 've',
      },
      {
        text: 'countries.vg',
        value: 'vg',
      },
      {
        text: 'countries.vi',
        value: 'vi',
      },
      {
        text: 'countries.vn',
        value: 'vn',
      },
      {
        text: 'countries.vu',
        value: 'vu',
      },
      {
        text: 'countries.wf',
        value: 'wf',
      },
      {
        text: 'countries.ws',
        value: 'ws',
      },
      {
        text: 'countries.xk',
        value: 'xk',
      },
      {
        text: 'countries.ye',
        value: 'ye',
      },
      {
        text: 'countries.yt',
        value: 'yt',
      },
      {
        text: 'countries.za',
        value: 'za',
      },
      {
        text: 'countries.zm',
        value: 'zm',
      },
      {
        text: 'countries.zw',
        value: 'zw',
      },
      {
        text: 'countries.other',
        value: 'other',
      },
    ],
    id: 'contacts-contacts__country',
    veeValidation: true,
    rules: ['required_if_show_mandatory:show_new_contact_address_fields'],
    warningRules: [],
    fieldClass: 'contacts-contacts__country--input',
    showError: true,
    errorClass: 'contacts-contacts__country--input-error',
    errorAttributes: [],
    showHelp: false,
    helpClass: 'contacts-contacts__country--input-help',
    helpAttributes: [],
    help: 'contacts.contacts.country.help',
    showFeedback: true,
    feedbackClass: 'contacts-contacts__country--input-feedback',
    feedbackAttributes: [],
    feedback: 'contacts.contacts.country.feedback',
    showLabel: true,
    labelClass: 'contacts-contacts__country--input-label',
    labelAttributes: {
      for: 'contacts-contacts__country',
    },
    placeholder: 'contacts.contacts.contact_detail.country.label',
  },
  phone: {
    fieldPath: 'phone',
    errorFieldPath: 'phone',
    fieldReadPath: 'phone',
    name: 'phone',
    label: 'contacts.contacts.contact_detail.phone1.label',
    id: 'contacts-contacts__phone',
    veeValidation: true,
    rules: ['required_if_show_mandatory:show_new_contact_phone1'],
    warningRules: [],
    fieldClass: 'contacts-contacts__phone--input',
    showError: true,
    errorClass: 'contacts-contacts__phone--input-error',
    errorAttributes: [],
    showHelp: false,
    helpClass: 'contacts-contacts__phone--input-help',
    helpAttributes: [],
    help: 'contacts.contacts.phone.help',
    showFeedback: true,
    feedbackClass: 'contacts-contacts__phone--input-feedback',
    feedbackAttributes: [],
    feedback: 'contacts.contacts.phone.feedback',
    showLabel: true,
    labelClass: 'contacts-contacts__phone--input-label',
    labelAttributes: {
      for: 'contacts-contacts__phone',
    },
  },
  phone2: {
    fieldPath: 'phone2',
    errorFieldPath: 'phone2',
    fieldReadPath: 'phone2',
    name: 'phone2',
    label: 'contacts.contacts.contact_detail.phone2.label',
    id: 'contacts-contacts__phone2',
    veeValidation: true,
    rules: ['required_if_show_mandatory:show_new_contact_phone2'],
    warningRules: [],
    fieldClass: 'contacts-contacts__phone2--input',
    showError: true,
    errorClass: 'contacts-contacts__phone2--input-error',
    errorAttributes: [],
    showHelp: false,
    helpClass: 'contacts-contacts__phone2--input-help',
    helpAttributes: [],
    help: 'contacts.contacts.phone2.help',
    showFeedback: true,
    feedbackClass: 'contacts-contacts__phone2--input-feedback',
    feedbackAttributes: [],
    feedback: 'contacts.contacts.phone2.feedback',
    showLabel: true,
    labelClass: 'contacts-contacts__phone2--input-label',
    labelAttributes: {
      for: 'contacts-contacts__phone2',
    },
  },
  email: {
    fieldPath: 'email',
    errorFieldPath: 'email',
    fieldReadPath: 'email',
    name: 'email',
    label: 'contacts.contacts.contact_detail.email1.label',
    id: 'contacts-contacts__email',
    veeValidation: true,
    rules: ['required_if_show_mandatory:show_new_contact_email1', 'email'],
    warningRules: [],
    fieldClass: 'contacts-contacts__email--input',
    showError: true,
    errorClass: 'contacts-contacts__email--input-error',
    errorAttributes: [],
    showHelp: false,
    helpClass: 'contacts-contacts__email--input-help',
    helpAttributes: [],
    help: 'contacts.contacts.email.help',
    showFeedback: true,
    feedbackClass: 'contacts-contacts__email--input-feedback',
    feedbackAttributes: [],
    feedback: 'contacts.contacts.email.feedback',
    showLabel: true,
    labelClass: 'contacts-contacts__email--input-label',
    labelAttributes: {
      for: 'contacts-contacts__email',
    },
  },
  email2: {
    fieldPath: 'email2',
    errorFieldPath: 'email2',
    fieldReadPath: 'email2',
    name: 'email2',
    label: 'contacts.contacts.contact_detail.email2.label',
    id: 'contacts-contacts__email2',
    veeValidation: true,
    rules: ['required_if_show_mandatory:show_new_contact_email2'],
    warningRules: [],
    fieldClass: 'contacts-contacts__email2--input',
    showError: true,
    errorClass: 'contacts-contacts__email2--input-error',
    errorAttributes: [],
    showHelp: false,
    helpClass: 'contacts-contacts__email2--input-help',
    helpAttributes: [],
    help: 'contacts.contacts.email2.help',
    showFeedback: true,
    feedbackClass: 'contacts-contacts__email2--input-feedback',
    feedbackAttributes: [],
    feedback: 'contacts.contacts.email2.feedback',
    showLabel: true,
    labelClass: 'contacts-contacts__email2--input-label',
    labelAttributes: {
      for: 'contacts-contacts__email2',
    },
  },
  id_card_number: {
    fieldPath: 'id_card_number',
    errorFieldPath: 'id_card_number',
    fieldReadPath: 'id_card_number',
    name: 'id_card_number',
    label: 'contacts.contacts.contact_individual.id_card_number.label',
    id: 'contacts-contacts__id-card-number',
    veeValidation: true,
    rules: ['required_if_show_mandatory:show_new_contact_national_number'],
    warningRules: [],
    fieldClass: 'contacts-contacts__id-card-number--input',
    showError: true,
    errorClass: 'contacts-contacts__id-card-number--input-error',
    errorAttributes: [],
    showHelp: false,
    helpClass: 'contacts-contacts__id-card-number--input-help',
    helpAttributes: [],
    help: 'contacts.contacts.id_card_number.help',
    showFeedback: true,
    feedbackClass: 'contacts-contacts__id-card-number--input-feedback',
    feedbackAttributes: [],
    feedback: 'contacts.contacts.id_card_number.feedback',
    showLabel: true,
    labelClass: 'contacts-contacts__id-card-number--input-label',
    labelAttributes: {
      for: 'contacts-contacts__id-card-number',
    },
  },
  passport_number: {
    fieldPath: 'passport_number',
    errorFieldPath: 'passport_number',
    fieldReadPath: 'passport_number',
    name: 'passport_number',
    label: 'contacts.contacts.contact_individual.passport_number.label',
    id: 'contacts-contacts__passport-number',
    veeValidation: true,
    rules: ['required_if_show_mandatory:show_new_contact_passport_number'],
    warningRules: [],
    fieldClass: 'contacts-contacts__passport-number--input',
    showError: true,
    errorClass: 'contacts-contacts__passport-number--input-error',
    errorAttributes: [],
    showHelp: false,
    helpClass: 'contacts-contacts__passport-number--input-help',
    helpAttributes: [],
    help: 'contacts.contacts.passport_number.help',
    showFeedback: true,
    feedbackClass: 'contacts-contacts__passport-number--input-feedback',
    feedbackAttributes: [],
    feedback: 'contacts.contacts.passport_number.feedback',
    showLabel: true,
    labelClass: 'contacts-contacts__passport-number--input-label',
    labelAttributes: {
      for: 'contacts-contacts__passport-number',
    },
  },
  registration_number: {
    fieldPath: 'registration_number',
    errorFieldPath: 'registration_number',
    fieldReadPath: 'registration_number',
    name: 'registration_number',
    label: 'contacts.contacts.contact_individual.registration_number.label',
    id: 'contacts-contacts__registration-number',
    veeValidation: true,
    rules: ['required_if_show_mandatory:show_new_contact_registration_number'],
    warningRules: [],
    fieldClass: 'contacts-contacts__registration-number--input',
    showError: true,
    errorClass: 'contacts-contacts__registration-number--input-error',
    errorAttributes: [],
    showHelp: false,
    helpClass: 'contacts-contacts__registration-number--input-help',
    helpAttributes: [],
    help: 'contacts.contacts.registration_number.help',
    showFeedback: true,
    feedbackClass: 'contacts-contacts__registration-number--input-feedback',
    feedbackAttributes: [],
    feedback: 'contacts.contacts.registration_number.feedback',
    showLabel: true,
    labelClass: 'contacts-contacts__registration-number--input-label',
    labelAttributes: {
      for: 'contacts-contacts__registration-number',
    },
  },
  external_reference: {
    fieldPath: 'external_reference',
    errorFieldPath: 'external_reference',
    fieldReadPath: 'external_reference',
    name: 'external_reference',
    label: 'contacts.contacts.external_reference.label',
    id: 'contacts-contacts__external-reference',
    veeValidation: true,
    rules: ['required_if_show_mandatory:show_new_contact_external_reference'],
    warningRules: [],
    fieldClass: 'contacts-contacts__external-reference--input',
    showError: true,
    errorClass: 'contacts-contacts__external-reference--input-error',
    errorAttributes: [],
    showHelp: false,
    helpClass: 'contacts-contacts__external-reference--input-help',
    helpAttributes: [],
    help: 'contacts.contacts.external_reference.help',
    showFeedback: true,
    feedbackClass: 'contacts-contacts__external-reference--input-feedback',
    feedbackAttributes: [],
    feedback: 'contacts.contacts.external_reference.feedback',
    showLabel: true,
    labelClass: 'contacts-contacts__external-reference--input-label',
    labelAttributes: {
      for: 'contacts-contacts__external-reference',
    },
  },
  contact_relation1_category_id: {
    fieldPath: 'contact_relation1_category_id',
    errorFieldPath: 'contact_relation1_category_id',
    fieldReadPath: 'contact_relation1_category_id',
    name: 'contact_relation1_category_id',
    label: 'contacts.contact.contact_relation1_category_id.label',
    id: 'contacts-contacts__contact_relation1_category-id',
    veeValidation: true,
    warningRules: [],
    fieldClass: 'contacts-contacts__contact_relation1_category-id--input',
    showError: true,
    errorClass: 'contacts-contacts__contact_relation1_category-id--input-error',
    errorAttributes: [],
    showHelp: false,
    helpClass: 'contacts-contacts__contact_relation1_category-id--input-help',
    helpAttributes: [],
    help: 'activities.activity.contact_relation1_category_id.help',
    showFeedback: true,
    feedbackClass: 'contacts-contacts__contact_relation1_category-id--input-feedback',
    feedbackAttributes: [],
    feedback: 'activities.activity.contact_relation1_category_id.feedback',
    showLabel: true,
    labelClass: 'contacts-contacts__contact_relation1_category-id--input-label',
    labelAttributes: {
      for: 'contacts-contacts__contact_relation1_category-id',
    },
  },
  contact_relation1_category: {
    fieldPath: 'contact_relation1_category',
    errorFieldPath: 'contact_relation1_category',
    fieldReadPath: 'contact_relation1_category',
    name: 'contact_relation1_category',
    label: 'contacts.contact.contact_relation1_category.label',
    id: 'contacts-contacts__contact_relation1_category',
    veeValidation: true,
    rules: ['nullable'],
    warningRules: [],
    fieldClass: 'contacts-contacts__contact_relation1_category--input',
    showError: true,
    errorClass: 'contacts-contacts__contact_relation1_category--input-error',
    errorAttributes: [],
    showHelp: false,
    helpClass: 'contacts-contacts__contact_relation1_category--input-help',
    helpAttributes: [],
    help: 'activities.activity.contact_relation1_category.help',
    showFeedback: true,
    feedbackClass: 'contacts-contacts__contact_relation1_category--input-feedback',
    feedbackAttributes: [],
    feedback: 'activities.activity.contact_relation1_category.feedback',
    showLabel: true,
    labelClass: 'activities-contact_relation1_category--input-label',
    labelAttributes: {
      for: 'contacts-contacts__contact_relation1_category',
    },
    selectLabel: 'name',
    selectEntity: 'contact-relation-category',
    selectMultiple: false,
    withTableSearch: false,
    withNew: false,
    filters: [
      {
        filterField: 'type',
        modelField: null,
        value: ['individual'],
      },
      {
        filterField: 'status',
        modelField: null,
        value: ['active'],
      },
    ],
  },
  relation1_firstname: {
    fieldPath: 'relation1_firstname',
    errorFieldPath: 'relation1_firstname',
    fieldReadPath: 'relation1_firstname',
    name: 'relation1_firstname',
    label: 'contacts.contacts.contact_individual.firstname.label',
    id: 'contacts-contacts__relation1-firstname',
    veeValidation: true,
    rules: ['required', 'string'],
    warningRules: [],
    fieldClass: 'contacts-contacts__relation1-firstname--input',
    showError: true,
    errorClass: 'contacts-contacts__relation1-firstname--input-error',
    errorAttributes: [],
    showHelp: false,
    helpClass: 'contacts-contacts__relation1-firstname--input-help',
    helpAttributes: [],
    help: 'contacts.contacts.relation1_firstname.help',
    showFeedback: true,
    feedbackClass: 'contacts-contacts__relation1-firstname--input-feedback',
    feedbackAttributes: [],
    feedback: 'contacts.contacts.relation1_firstname.feedback',
    showLabel: true,
    labelClass: 'contacts-contacts__relation1-firstname--input-label',
    labelAttributes: {
      for: 'contacts-contacts__relation1-firstname',
    },
  },
  relation1_lastname: {
    fieldPath: 'relation1_lastname',
    errorFieldPath: 'relation1_lastname',
    fieldReadPath: 'relation1_lastname',
    name: 'relation1_lastname',
    label: 'contacts.contacts.contact_individual.lastname.label',
    id: 'contacts-contacts__relation1-lastname',
    veeValidation: true,
    rules: ['required', 'string'],
    warningRules: [],
    fieldClass: 'contacts-contacts__relation1-lastname--input',
    showError: true,
    errorClass: 'contacts-contacts__relation1-lastname--input-error',
    errorAttributes: [],
    showHelp: false,
    helpClass: 'contacts-contacts__relation1-lastname--input-help',
    helpAttributes: [],
    help: 'contacts.contacts.relation1_lastname.help',
    showFeedback: true,
    feedbackClass: 'contacts-contacts__relation1-lastname--input-feedback',
    feedbackAttributes: [],
    feedback: 'contacts.contacts.relation1_lastname.feedback',
    showLabel: true,
    labelClass: 'contacts-contacts__relation1-lastname--input-label',
    labelAttributes: {
      for: 'contacts-contacts__relation1-lastname',
    },
  },
  relation1_birthdate: {
    fieldPath: 'relation1_birthdate',
    errorFieldPath: 'relation1_birthdate',
    fieldReadPath: 'relation1_birthdate',
    name: 'relation1_birthdate',
    label: 'contacts.contacts.contact_individual.birthdate.label',
    id: 'contacts-contacts__relation1-birthdate',
    veeValidation: true,
    rules: ['required_if_show_mandatory:show_new_contact_relation1_birthdate'],
    warningRules: [],
    fieldClass: 'contacts-contacts__relation1-birthdate--input',
    showError: true,
    errorClass: 'contacts-contacts__relation1-birthdate--input-error',
    errorAttributes: [],
    showHelp: false,
    helpClass: 'contacts-contacts__relation1-birthdate--input-help',
    helpAttributes: [],
    help: 'contacts.contacts.relation1_birthdate.help',
    showFeedback: true,
    feedbackClass: 'contacts-contacts__relation1-birthdate--input-feedback',
    feedbackAttributes: [],
    feedback: 'contacts.contacts.relation1_birthdate.feedback',
    showLabel: true,
    labelClass: 'contacts-contacts__relation1-birthdate--input-label',
    labelAttributes: {
      for: 'contacts-contacts__relation1-birthdate',
    },
  },
  relation1_gender: {
    fieldPath: 'relation1_gender',
    errorFieldPath: 'relation1_gender',
    fieldReadPath: 'relation1_gender',
    name: 'relation1_gender',
    label: 'contacts.contacts.contact_individual.gender.label',
    options: [
      {
        text: 'global.contact_individual.gender.placeholder',
        value: null,
      },
      {
        text: 'global.contact_individual.man',
        value: 'M',
      },
      {
        text: 'global.contact_individual.woman',
        value: 'W',
      },
      {
        text: 'global.contact_individual.na',
        value: '-',
      },
    ],
    id: 'contacts-contacts__relation1-gender',
    veeValidation: true,
    rules: ['required_if_show_mandatory:show_new_contact_relation1_gender'],
    warningRules: [],
    fieldClass: 'contacts-contacts__relation1-gender--input',
    showError: true,
    errorClass: 'contacts-contacts__relation1-gender--input-error',
    errorAttributes: [],
    showHelp: false,
    helpClass: 'contacts-contacts__relation1-gender--input-help',
    helpAttributes: [],
    help: 'contacts.contacts.relation1_gender.help',
    showFeedback: true,
    feedbackClass: 'contacts-contacts__relation1-gender--input-feedback',
    feedbackAttributes: [],
    feedback: 'contacts.contacts.relation1_gender.feedback',
    showLabel: true,
    labelClass: 'contacts-contacts__relation1-gender--input-label',
    labelAttributes: {
      for: 'contacts-contacts__relation1-gender',
    },
  },
  relation1_street: {
    fieldPath: 'relation1_street',
    errorFieldPath: 'relation1_street',
    fieldReadPath: 'relation1_street',
    name: 'relation1_street',
    label: 'contacts.contacts.contact_detail.street.label',
    id: 'contacts-contacts__relation1-street',
    veeValidation: true,
    rules: ['required_if_show_mandatory:show_new_contact_relation1_address_fields'],
    warningRules: [],
    fieldClass: 'contacts-contacts__relation1-street--input',
    showError: true,
    errorClass: 'contacts-contacts__relation1-street--input-error',
    errorAttributes: [],
    showHelp: false,
    helpClass: 'contacts-contacts__relation1-street--input-help',
    helpAttributes: [],
    help: 'contacts.contacts.relation1_street.help',
    showFeedback: true,
    feedbackClass: 'contacts-contacts__relation1-street--input-feedback',
    feedbackAttributes: [],
    feedback: 'contacts.contacts.relation1_street.feedback',
    showLabel: true,
    labelClass: 'contacts-contacts__relation1-street--input-label',
    labelAttributes: {
      for: 'contacts-contacts__relation1-street',
    },
    placeholder: 'contacts.contacts.contact_detail.street.label',
  },
  relation1_street2: {
    fieldPath: 'relation1_street2',
    errorFieldPath: 'relation1_street2',
    fieldReadPath: 'relation1_street2',
    name: 'relation1_street2',
    label: 'ㅤ',
    id: 'contacts-contacts__relation1-street2',
    veeValidation: true,
    rules: ['nullable'],
    warningRules: [],
    fieldClass: 'contacts-contacts__relation1-street2--input',
    showError: true,
    errorClass: 'contacts-contacts__relation1-street2--input-error',
    errorAttributes: [],
    showHelp: false,
    helpClass: 'contacts-contacts__relation1-street2--input-help',
    helpAttributes: [],
    help: 'contacts.contacts.relation1_street2.help',
    showFeedback: true,
    feedbackClass: 'contacts-contacts__relation1-street2--input-feedback',
    feedbackAttributes: [],
    feedback: 'contacts.contacts.relation1_street2.feedback',
    showLabel: true,
    labelClass: 'contacts-contacts__relation1-street2--input-label',
    labelAttributes: {
      for: 'contacts-contacts__relation1-street2',
    },
    placeholder: 'contacts.contacts.contact_detail.street2.label',
  },
  relation1_zip: {
    fieldPath: 'relation1_zip',
    errorFieldPath: 'relation1_zip',
    fieldReadPath: 'relation1_zip',
    name: 'relation1_zip',
    label: '',
    id: 'contacts-contacts__relation1-zip',
    veeValidation: true,
    rules: ['required_if_show_mandatory:show_new_contact_relation1_address_fields'],
    warningRules: [],
    fieldClass: 'contacts-contacts__relation1-zip--input',
    showError: true,
    errorClass: 'contacts-contacts__relation1-zip--input-error',
    errorAttributes: [],
    showHelp: false,
    helpClass: 'contacts-contacts__relation1-zip--input-help',
    helpAttributes: [],
    help: 'contacts.contacts.relation1_zip.help',
    showFeedback: true,
    feedbackClass: 'contacts-contacts__relation1-zip--input-feedback',
    feedbackAttributes: [],
    feedback: 'contacts.contacts.relation1_zip.feedback',
    showLabel: true,
    labelClass: 'contacts-contacts__relation1-zip--input-label',
    labelAttributes: {
      for: 'contacts-contacts__relation1-zip',
    },
    placeholder: 'contacts.contacts.contact_detail.zip.label',
  },
  relation1_city: {
    fieldPath: 'relation1_city',
    errorFieldPath: 'relation1_city',
    fieldReadPath: 'relation1_city',
    name: 'relation1_city',
    label: '',
    id: 'contacts-contacts__relation1-city',
    veeValidation: true,
    rules: ['required_if_show_mandatory:show_new_contact_relation1_address_fields'],
    warningRules: [],
    fieldClass: 'contacts-contacts__relation1-city--input',
    showError: true,
    errorClass: 'contacts-contacts__relation1-city--input-error',
    errorAttributes: [],
    showHelp: false,
    helpClass: 'contacts-contacts__relation1-city--input-help',
    helpAttributes: [],
    help: 'contacts.contacts.relation1_city.help',
    showFeedback: true,
    feedbackClass: 'contacts-contacts__relation1-city--input-feedback',
    feedbackAttributes: [],
    feedback: 'contacts.contacts.relation1_city.feedback',
    showLabel: true,
    labelClass: 'contacts-contacts__relation1-city--input-label',
    labelAttributes: {
      for: 'contacts-contacts__relation1-city',
    },
    placeholder: 'contacts.contacts.contact_detail.city.label',
  },
  relation1_country: {
    fieldPath: 'relation1_country',
    errorFieldPath: 'relation1_country',
    fieldReadPath: 'relation1_country',
    name: 'relation1_country',
    label: '',
    options: [
      {
        text: 'countries.placeholder',
        value: 'null',
      },
      {
        text: 'countries.ad',
        value: 'ad',
      },
      {
        text: 'countries.ae',
        value: 'ae',
      },
      {
        text: 'countries.af',
        value: 'af',
      },
      {
        text: 'countries.ag',
        value: 'ag',
      },
      {
        text: 'countries.ai',
        value: 'ai',
      },
      {
        text: 'countries.al',
        value: 'al',
      },
      {
        text: 'countries.am',
        value: 'am',
      },
      {
        text: 'countries.ao',
        value: 'ao',
      },
      {
        text: 'countries.aq',
        value: 'aq',
      },
      {
        text: 'countries.ar',
        value: 'ar',
      },
      {
        text: 'countries.as',
        value: 'as',
      },
      {
        text: 'countries.at',
        value: 'at',
      },
      {
        text: 'countries.au',
        value: 'au',
      },
      {
        text: 'countries.aw',
        value: 'aw',
      },
      {
        text: 'countries.ax',
        value: 'ax',
      },
      {
        text: 'countries.az',
        value: 'az',
      },
      {
        text: 'countries.ba',
        value: 'ba',
      },
      {
        text: 'countries.bb',
        value: 'bb',
      },
      {
        text: 'countries.bd',
        value: 'bd',
      },
      {
        text: 'countries.be',
        value: 'be',
      },
      {
        text: 'countries.bf',
        value: 'bf',
      },
      {
        text: 'countries.bg',
        value: 'bg',
      },
      {
        text: 'countries.bh',
        value: 'bh',
      },
      {
        text: 'countries.bi',
        value: 'bi',
      },
      {
        text: 'countries.bj',
        value: 'bj',
      },
      {
        text: 'countries.bl',
        value: 'bl',
      },
      {
        text: 'countries.bm',
        value: 'bm',
      },
      {
        text: 'countries.bn',
        value: 'bn',
      },
      {
        text: 'countries.bo',
        value: 'bo',
      },
      {
        text: 'countries.bq',
        value: 'bq',
      },
      {
        text: 'countries.br',
        value: 'br',
      },
      {
        text: 'countries.bs',
        value: 'bs',
      },
      {
        text: 'countries.bt',
        value: 'bt',
      },
      {
        text: 'countries.bv',
        value: 'bv',
      },
      {
        text: 'countries.bw',
        value: 'bw',
      },
      {
        text: 'countries.by',
        value: 'by',
      },
      {
        text: 'countries.bz',
        value: 'bz',
      },
      {
        text: 'countries.ca',
        value: 'ca',
      },
      {
        text: 'countries.cc',
        value: 'cc',
      },
      {
        text: 'countries.cd',
        value: 'cd',
      },
      {
        text: 'countries.cf',
        value: 'cf',
      },
      {
        text: 'countries.cg',
        value: 'cg',
      },
      {
        text: 'countries.ch',
        value: 'ch',
      },
      {
        text: 'countries.ci',
        value: 'ci',
      },
      {
        text: 'countries.ck',
        value: 'ck',
      },
      {
        text: 'countries.cl',
        value: 'cl',
      },
      {
        text: 'countries.cm',
        value: 'cm',
      },
      {
        text: 'countries.cn',
        value: 'cn',
      },
      {
        text: 'countries.co',
        value: 'co',
      },
      {
        text: 'countries.cr',
        value: 'cr',
      },
      {
        text: 'countries.cu',
        value: 'cu',
      },
      {
        text: 'countries.cv',
        value: 'cv',
      },
      {
        text: 'countries.cw',
        value: 'cw',
      },
      {
        text: 'countries.cx',
        value: 'cx',
      },
      {
        text: 'countries.cy',
        value: 'cy',
      },
      {
        text: 'countries.cz',
        value: 'cz',
      },
      {
        text: 'countries.de',
        value: 'de',
      },
      {
        text: 'countries.dj',
        value: 'dj',
      },
      {
        text: 'countries.dk',
        value: 'dk',
      },
      {
        text: 'countries.dm',
        value: 'dm',
      },
      {
        text: 'countries.do',
        value: 'do',
      },
      {
        text: 'countries.dz',
        value: 'dz',
      },
      {
        text: 'countries.ec',
        value: 'ec',
      },
      {
        text: 'countries.ee',
        value: 'ee',
      },
      {
        text: 'countries.eg',
        value: 'eg',
      },
      {
        text: 'countries.eh',
        value: 'eh',
      },
      {
        text: 'countries.er',
        value: 'er',
      },
      {
        text: 'countries.es',
        value: 'es',
      },
      {
        text: 'countries.et',
        value: 'et',
      },
      {
        text: 'countries.fi',
        value: 'fi',
      },
      {
        text: 'countries.fj',
        value: 'fj',
      },
      {
        text: 'countries.fk',
        value: 'fk',
      },
      {
        text: 'countries.fm',
        value: 'fm',
      },
      {
        text: 'countries.fo',
        value: 'fo',
      },
      {
        text: 'countries.fr',
        value: 'fr',
      },
      {
        text: 'countries.ga',
        value: 'ga',
      },
      {
        text: 'countries.gb',
        value: 'gb',
      },
      {
        text: 'countries.gd',
        value: 'gd',
      },
      {
        text: 'countries.ge',
        value: 'ge',
      },
      {
        text: 'countries.gf',
        value: 'gf',
      },
      {
        text: 'countries.gg',
        value: 'gg',
      },
      {
        text: 'countries.gh',
        value: 'gh',
      },
      {
        text: 'countries.gi',
        value: 'gi',
      },
      {
        text: 'countries.gl',
        value: 'gl',
      },
      {
        text: 'countries.gm',
        value: 'gm',
      },
      {
        text: 'countries.gn',
        value: 'gn',
      },
      {
        text: 'countries.gp',
        value: 'gp',
      },
      {
        text: 'countries.gq',
        value: 'gq',
      },
      {
        text: 'countries.gr',
        value: 'gr',
      },
      {
        text: 'countries.gs',
        value: 'gs',
      },
      {
        text: 'countries.gt',
        value: 'gt',
      },
      {
        text: 'countries.gu',
        value: 'gu',
      },
      {
        text: 'countries.gw',
        value: 'gw',
      },
      {
        text: 'countries.gy',
        value: 'gy',
      },
      {
        text: 'countries.hk',
        value: 'hk',
      },
      {
        text: 'countries.hm',
        value: 'hm',
      },
      {
        text: 'countries.hn',
        value: 'hn',
      },
      {
        text: 'countries.hr',
        value: 'hr',
      },
      {
        text: 'countries.ht',
        value: 'ht',
      },
      {
        text: 'countries.hu',
        value: 'hu',
      },
      {
        text: 'countries.id',
        value: 'id',
      },
      {
        text: 'countries.ie',
        value: 'ie',
      },
      {
        text: 'countries.il',
        value: 'il',
      },
      {
        text: 'countries.im',
        value: 'im',
      },
      {
        text: 'countries.in',
        value: 'in',
      },
      {
        text: 'countries.io',
        value: 'io',
      },
      {
        text: 'countries.iq',
        value: 'iq',
      },
      {
        text: 'countries.ir',
        value: 'ir',
      },
      {
        text: 'countries.is',
        value: 'is',
      },
      {
        text: 'countries.it',
        value: 'it',
      },
      {
        text: 'countries.je',
        value: 'je',
      },
      {
        text: 'countries.jm',
        value: 'jm',
      },
      {
        text: 'countries.jo',
        value: 'jo',
      },
      {
        text: 'countries.jp',
        value: 'jp',
      },
      {
        text: 'countries.ke',
        value: 'ke',
      },
      {
        text: 'countries.kg',
        value: 'kg',
      },
      {
        text: 'countries.kh',
        value: 'kh',
      },
      {
        text: 'countries.ki',
        value: 'ki',
      },
      {
        text: 'countries.km',
        value: 'km',
      },
      {
        text: 'countries.kn',
        value: 'kn',
      },
      {
        text: 'countries.kp',
        value: 'kp',
      },
      {
        text: 'countries.kr',
        value: 'kr',
      },
      {
        text: 'countries.kw',
        value: 'kw',
      },
      {
        text: 'countries.ky',
        value: 'ky',
      },
      {
        text: 'countries.kz',
        value: 'kz',
      },
      {
        text: 'countries.la',
        value: 'la',
      },
      {
        text: 'countries.lb',
        value: 'lb',
      },
      {
        text: 'countries.lc',
        value: 'lc',
      },
      {
        text: 'countries.li',
        value: 'li',
      },
      {
        text: 'countries.lk',
        value: 'lk',
      },
      {
        text: 'countries.lr',
        value: 'lr',
      },
      {
        text: 'countries.ls',
        value: 'ls',
      },
      {
        text: 'countries.lt',
        value: 'lt',
      },
      {
        text: 'countries.lu',
        value: 'lu',
      },
      {
        text: 'countries.lv',
        value: 'lv',
      },
      {
        text: 'countries.ly',
        value: 'ly',
      },
      {
        text: 'countries.ma',
        value: 'ma',
      },
      {
        text: 'countries.mc',
        value: 'mc',
      },
      {
        text: 'countries.md',
        value: 'md',
      },
      {
        text: 'countries.me',
        value: 'me',
      },
      {
        text: 'countries.mf',
        value: 'mf',
      },
      {
        text: 'countries.mg',
        value: 'mg',
      },
      {
        text: 'countries.mh',
        value: 'mh',
      },
      {
        text: 'countries.mk',
        value: 'mk',
      },
      {
        text: 'countries.ml',
        value: 'ml',
      },
      {
        text: 'countries.mm',
        value: 'mm',
      },
      {
        text: 'countries.mn',
        value: 'mn',
      },
      {
        text: 'countries.mo',
        value: 'mo',
      },
      {
        text: 'countries.mp',
        value: 'mp',
      },
      {
        text: 'countries.mq',
        value: 'mq',
      },
      {
        text: 'countries.mr',
        value: 'mr',
      },
      {
        text: 'countries.ms',
        value: 'ms',
      },
      {
        text: 'countries.mt',
        value: 'mt',
      },
      {
        text: 'countries.mu',
        value: 'mu',
      },
      {
        text: 'countries.mv',
        value: 'mv',
      },
      {
        text: 'countries.mw',
        value: 'mw',
      },
      {
        text: 'countries.mx',
        value: 'mx',
      },
      {
        text: 'countries.my',
        value: 'my',
      },
      {
        text: 'countries.mz',
        value: 'mz',
      },
      {
        text: 'countries.na',
        value: 'na',
      },
      {
        text: 'countries.nc',
        value: 'nc',
      },
      {
        text: 'countries.ne',
        value: 'ne',
      },
      {
        text: 'countries.nf',
        value: 'nf',
      },
      {
        text: 'countries.ng',
        value: 'ng',
      },
      {
        text: 'countries.ni',
        value: 'ni',
      },
      {
        text: 'countries.nl',
        value: 'nl',
      },
      {
        text: 'countries.no',
        value: 'no',
      },
      {
        text: 'countries.np',
        value: 'np',
      },
      {
        text: 'countries.nr',
        value: 'nr',
      },
      {
        text: 'countries.nu',
        value: 'nu',
      },
      {
        text: 'countries.nz',
        value: 'nz',
      },
      {
        text: 'countries.om',
        value: 'om',
      },
      {
        text: 'countries.pa',
        value: 'pa',
      },
      {
        text: 'countries.pe',
        value: 'pe',
      },
      {
        text: 'countries.pf',
        value: 'pf',
      },
      {
        text: 'countries.pg',
        value: 'pg',
      },
      {
        text: 'countries.ph',
        value: 'ph',
      },
      {
        text: 'countries.pk',
        value: 'pk',
      },
      {
        text: 'countries.pl',
        value: 'pl',
      },
      {
        text: 'countries.pm',
        value: 'pm',
      },
      {
        text: 'countries.pn',
        value: 'pn',
      },
      {
        text: 'countries.pr',
        value: 'pr',
      },
      {
        text: 'countries.ps',
        value: 'ps',
      },
      {
        text: 'countries.pt',
        value: 'pt',
      },
      {
        text: 'countries.pw',
        value: 'pw',
      },
      {
        text: 'countries.py',
        value: 'py',
      },
      {
        text: 'countries.qa',
        value: 'qa',
      },
      {
        text: 'countries.re',
        value: 're',
      },
      {
        text: 'countries.ro',
        value: 'ro',
      },
      {
        text: 'countries.rs',
        value: 'rs',
      },
      {
        text: 'countries.ru',
        value: 'ru',
      },
      {
        text: 'countries.rw',
        value: 'rw',
      },
      {
        text: 'countries.sa',
        value: 'sa',
      },
      {
        text: 'countries.sb',
        value: 'sb',
      },
      {
        text: 'countries.sc',
        value: 'sc',
      },
      {
        text: 'countries.sd',
        value: 'sd',
      },
      {
        text: 'countries.se',
        value: 'se',
      },
      {
        text: 'countries.sg',
        value: 'sg',
      },
      {
        text: 'countries.sh',
        value: 'sh',
      },
      {
        text: 'countries.si',
        value: 'si',
      },
      {
        text: 'countries.sj',
        value: 'sj',
      },
      {
        text: 'countries.sk',
        value: 'sk',
      },
      {
        text: 'countries.sl',
        value: 'sl',
      },
      {
        text: 'countries.sm',
        value: 'sm',
      },
      {
        text: 'countries.sn',
        value: 'sn',
      },
      {
        text: 'countries.so',
        value: 'so',
      },
      {
        text: 'countries.sr',
        value: 'sr',
      },
      {
        text: 'countries.ss',
        value: 'ss',
      },
      {
        text: 'countries.st',
        value: 'st',
      },
      {
        text: 'countries.sv',
        value: 'sv',
      },
      {
        text: 'countries.sx',
        value: 'sx',
      },
      {
        text: 'countries.sy',
        value: 'sy',
      },
      {
        text: 'countries.sz',
        value: 'sz',
      },
      {
        text: 'countries.tc',
        value: 'tc',
      },
      {
        text: 'countries.td',
        value: 'td',
      },
      {
        text: 'countries.tf',
        value: 'tf',
      },
      {
        text: 'countries.tg',
        value: 'tg',
      },
      {
        text: 'countries.th',
        value: 'th',
      },
      {
        text: 'countries.tj',
        value: 'tj',
      },
      {
        text: 'countries.tk',
        value: 'tk',
      },
      {
        text: 'countries.tl',
        value: 'tl',
      },
      {
        text: 'countries.tm',
        value: 'tm',
      },
      {
        text: 'countries.tn',
        value: 'tn',
      },
      {
        text: 'countries.to',
        value: 'to',
      },
      {
        text: 'countries.tr',
        value: 'tr',
      },
      {
        text: 'countries.tt',
        value: 'tt',
      },
      {
        text: 'countries.tv',
        value: 'tv',
      },
      {
        text: 'countries.tw',
        value: 'tw',
      },
      {
        text: 'countries.tz',
        value: 'tz',
      },
      {
        text: 'countries.ua',
        value: 'ua',
      },
      {
        text: 'countries.ug',
        value: 'ug',
      },
      {
        text: 'countries.um',
        value: 'um',
      },
      {
        text: 'countries.us',
        value: 'us',
      },
      {
        text: 'countries.uy',
        value: 'uy',
      },
      {
        text: 'countries.uz',
        value: 'uz',
      },
      {
        text: 'countries.va',
        value: 'va',
      },
      {
        text: 'countries.vc',
        value: 'vc',
      },
      {
        text: 'countries.ve',
        value: 've',
      },
      {
        text: 'countries.vg',
        value: 'vg',
      },
      {
        text: 'countries.vi',
        value: 'vi',
      },
      {
        text: 'countries.vn',
        value: 'vn',
      },
      {
        text: 'countries.vu',
        value: 'vu',
      },
      {
        text: 'countries.wf',
        value: 'wf',
      },
      {
        text: 'countries.ws',
        value: 'ws',
      },
      {
        text: 'countries.xk',
        value: 'xk',
      },
      {
        text: 'countries.ye',
        value: 'ye',
      },
      {
        text: 'countries.yt',
        value: 'yt',
      },
      {
        text: 'countries.za',
        value: 'za',
      },
      {
        text: 'countries.zm',
        value: 'zm',
      },
      {
        text: 'countries.zw',
        value: 'zw',
      },
      {
        text: 'countries.other',
        value: 'other',
      },
    ],
    id: 'contacts-contacts__relation1-country',
    veeValidation: true,
    rules: ['required_if_show_mandatory:show_new_contact_relation1_address_fields'],
    warningRules: [],
    fieldClass: 'contacts-contacts__relation1-country--input',
    showError: true,
    errorClass: 'contacts-contacts__relation1-country--input-error',
    errorAttributes: [],
    showHelp: false,
    helpClass: 'contacts-contacts__relation1-country--input-help',
    helpAttributes: [],
    help: 'contacts.contacts.relation1_country.help',
    showFeedback: true,
    feedbackClass: 'contacts-contacts__relation1-country--input-feedback',
    feedbackAttributes: [],
    feedback: 'contacts.contacts.relation1_country.feedback',
    showLabel: true,
    labelClass: 'contacts-contacts__relation1-country--input-label',
    labelAttributes: {
      for: 'contacts-contacts__relation1-country',
    },
    placeholder: 'contacts.contacts.contact_detail.country.label',
  },
  relation1_phone: {
    fieldPath: 'relation1_phone',
    errorFieldPath: 'relation1_phone',
    fieldReadPath: 'relation1_phone',
    name: 'relation1_phone',
    label: 'contacts.contacts.contact_detail.phone1.label',
    id: 'contacts-contacts__relation1-phone',
    veeValidation: true,
    rules: ['required_if_show_mandatory:show_new_contact_relation1_phone1'],
    warningRules: [],
    fieldClass: 'contacts-contacts__relation1-phone--input',
    showError: true,
    errorClass: 'contacts-contacts__relation1-phone--input-error',
    errorAttributes: [],
    showHelp: false,
    helpClass: 'contacts-contacts__relation1-phone--input-help',
    helpAttributes: [],
    help: 'contacts.contacts.relation1_phone.help',
    showFeedback: true,
    feedbackClass: 'contacts-contacts__relation1-phone--input-feedback',
    feedbackAttributes: [],
    feedback: 'contacts.contacts.relation1_phone.feedback',
    showLabel: true,
    labelClass: 'contacts-contacts__relation1-phone--input-label',
    labelAttributes: {
      for: 'contacts-contacts__relation1-phone',
    },
  },
  relation1_phone2: {
    fieldPath: 'relation1_phone2',
    errorFieldPath: 'relation1_phone2',
    fieldReadPath: 'relation1_phone2',
    name: 'relation1_phone2',
    label: 'contacts.contacts.contact_detail.phone2.label',
    id: 'contacts-contacts__relation1-phone2',
    veeValidation: true,
    rules: ['required_if_show_mandatory:show_new_contact_relation1_phone2'],
    warningRules: [],
    fieldClass: 'contacts-contacts__relation1-phone2--input',
    showError: true,
    errorClass: 'contacts-contacts__relation1-phone2--input-error',
    errorAttributes: [],
    showHelp: false,
    helpClass: 'contacts-contacts__relation1-phone2--input-help',
    helpAttributes: [],
    help: 'contacts.contacts.relation1_phone2.help',
    showFeedback: true,
    feedbackClass: 'contacts-contacts__relation1-phone2--input-feedback',
    feedbackAttributes: [],
    feedback: 'contacts.contacts.relation1_phone2.feedback',
    showLabel: true,
    labelClass: 'contacts-contacts__relation1-phone2--input-label',
    labelAttributes: {
      for: 'contacts-contacts__relation1-phone2',
    },
  },
  relation1_email: {
    fieldPath: 'relation1_email',
    errorFieldPath: 'relation1_email',
    fieldReadPath: 'relation1_email',
    name: 'relation1_email',
    label: 'contacts.contacts.contact_detail.email1.label',
    id: 'contacts-contacts__relation1-email',
    veeValidation: true,
    rules: ['required_if_show_mandatory:show_new_contact_relation1_email1', 'email'],
    warningRules: [],
    fieldClass: 'contacts-contacts__relation1-email--input',
    showError: true,
    errorClass: 'contacts-contacts__relation1-email--input-error',
    errorAttributes: [],
    showHelp: false,
    helpClass: 'contacts-contacts__relation1-email--input-help',
    helpAttributes: [],
    help: 'contacts.contacts.relation1_email.help',
    showFeedback: true,
    feedbackClass: 'contacts-contacts__relation1-email--input-feedback',
    feedbackAttributes: [],
    feedback: 'contacts.contacts.relation1_email.feedback',
    showLabel: true,
    labelClass: 'contacts-contacts__relation1-email--input-label',
    labelAttributes: {
      for: 'contacts-contacts__relation1-email',
    },
  },
  relation1_email2: {
    fieldPath: 'relation1_email2',
    errorFieldPath: 'relation1_email2',
    fieldReadPath: 'relation1_email2',
    name: 'relation1_email2',
    label: 'contacts.contacts.contact_detail.email2.label',
    id: 'contacts-contacts__relation1-email2',
    veeValidation: true,
    rules: ['required_if_show_mandatory:show_new_contact_relation1_email2'],
    warningRules: [],
    fieldClass: 'contacts-contacts__relation1-email2--input',
    showError: true,
    errorClass: 'contacts-contacts__relation1-email2--input-error',
    errorAttributes: [],
    showHelp: false,
    helpClass: 'contacts-contacts__relation1-email2--input-help',
    helpAttributes: [],
    help: 'contacts.contacts.relation1_email2.help',
    showFeedback: true,
    feedbackClass: 'contacts-contacts__relation1-email2--input-feedback',
    feedbackAttributes: [],
    feedback: 'contacts.contacts.relation1_email2.feedback',
    showLabel: true,
    labelClass: 'contacts-contacts__relation1-email2--input-label',
    labelAttributes: {
      for: 'contacts-contacts__relation1-email2',
    },
  },
  relation1_id_card_number: {
    fieldPath: 'relation1_id_card_number',
    errorFieldPath: 'relation1_id_card_number',
    fieldReadPath: 'relation1_id_card_number',
    name: 'relation1_id_card_number',
    label: 'contacts.contacts.contact_individual.id_card_number.label',
    id: 'contacts-contacts__relation1-id-card-number',
    veeValidation: true,
    rules: ['required_if_show_mandatory:show_new_contact_relation1_id_card_number'],
    warningRules: [],
    fieldClass: 'contacts-contacts__relation1-id-card-number--input',
    showError: true,
    errorClass: 'contacts-contacts__relation1-id-card-number--input-error',
    errorAttributes: [],
    showHelp: false,
    helpClass: 'contacts-contacts__relation1-id-card-number--input-help',
    helpAttributes: [],
    help: 'contacts.contacts.relation1_id_card_number.help',
    showFeedback: true,
    feedbackClass: 'contacts-contacts__relation1-id-card-number--input-feedback',
    feedbackAttributes: [],
    feedback: 'contacts.contacts.relation1_id_card_number.feedback',
    showLabel: true,
    labelClass: 'contacts-contacts__relation1-id-card-number--input-label',
    labelAttributes: {
      for: 'contacts-contacts__relation1-id-card-number',
    },
  },
  relation1_passport_number: {
    fieldPath: 'relation1_passport_number',
    errorFieldPath: 'relation1_passport_number',
    fieldReadPath: 'relation1_passport_number',
    name: 'relation1_passport_number',
    label: 'contacts.contacts.contact_individual.passport_number.label',
    id: 'contacts-contacts__relation1-passport-number',
    veeValidation: true,
    rules: ['required_if_show_mandatory:show_new_contact_relation1_passport_number'],
    warningRules: [],
    fieldClass: 'contacts-contacts__relation1-passport-number--input',
    showError: true,
    errorClass: 'contacts-contacts__relation1-passport-number--input-error',
    errorAttributes: [],
    showHelp: false,
    helpClass: 'contacts-contacts__relation1-passport-number--input-help',
    helpAttributes: [],
    help: 'contacts.contacts.relation1_passport_number.help',
    showFeedback: true,
    feedbackClass: 'contacts-contacts__relation1-passport-number--input-feedback',
    feedbackAttributes: [],
    feedback: 'contacts.contacts.relation1_passport_number.feedback',
    showLabel: true,
    labelClass: 'contacts-contacts__relation1-passport-number--input-label',
    labelAttributes: {
      for: 'contacts-contacts__relation1-passport-number',
    },
  },
  relation1_registration_number: {
    fieldPath: 'relation1_registration_number',
    errorFieldPath: 'relation1_registration_number',
    fieldReadPath: 'relation1_registration_number',
    name: 'relation1_registration_number',
    label: 'contacts.contacts.contact_individual.registration_number.label',
    id: 'contacts-contacts__relation1-registration-number',
    veeValidation: true,
    rules: ['required_if_show_mandatory:show_new_contact_relation1_registration_number'],
    warningRules: [],
    fieldClass: 'contacts-contacts__relation1-registration-number--input',
    showError: true,
    errorClass: 'contacts-contacts__relation1-registration-number--input-error',
    errorAttributes: [],
    showHelp: false,
    helpClass: 'contacts-contacts__relation1-registration-number--input-help',
    helpAttributes: [],
    help: 'contacts.contacts.relation1_registration_number.help',
    showFeedback: true,
    feedbackClass: 'contacts-contacts__relation1-registration-number--input-feedback',
    feedbackAttributes: [],
    feedback: 'contacts.contacts.relation1_registration_number.feedback',
    showLabel: true,
    labelClass: 'contacts-contacts__relation1-registration-number--input-label',
    labelAttributes: {
      for: 'contacts-contacts__relation1-registration-number',
    },
  },
  relation1_external_reference: {
    fieldPath: 'relation1_external_reference',
    errorFieldPath: 'relation1_external_reference',
    fieldReadPath: 'relation1_external_reference',
    name: 'relation1_external_reference',
    label: 'contacts.contacts.external_reference.label',
    id: 'contacts-contacts__relation1-external-reference',
    veeValidation: true,
    rules: ['required_if_show_mandatory:show_new_contact_relation1_external_reference'],
    warningRules: [],
    fieldClass: 'contacts-contacts__relation1-external-reference--input',
    showError: true,
    errorClass: 'contacts-contacts__relation1-external-reference--input-error',
    errorAttributes: [],
    showHelp: false,
    helpClass: 'contacts-contacts__relation1-external-reference--input-help',
    helpAttributes: [],
    help: 'contacts.contacts.relation1_external_reference.help',
    showFeedback: true,
    feedbackClass: 'contacts-contacts__relation1-external-reference--input-feedback',
    feedbackAttributes: [],
    feedback: 'contacts.contacts.relation1_external_reference.feedback',
    showLabel: true,
    labelClass: 'contacts-contacts__relation1-external-reference--input-label',
    labelAttributes: {
      for: 'contacts-contacts__relation1-external-reference',
    },
  },
  contact_relation2_category_id: {
    fieldPath: 'contact_relation2_category_id',
    errorFieldPath: 'contact_relation2_category_id',
    fieldReadPath: 'contact_relation2_category_id',
    name: 'contact_relation2_category_id',
    label: 'contacts.contact.contact_relation2_category_id.label',
    id: 'contacts-contacts__contact_relation2_category-id',
    veeValidation: true,
    warningRules: [],
    fieldClass: 'contacts-contacts__contact_relation2_category-id--input',
    showError: true,
    errorClass: 'contacts-contacts__contact_relation2_category-id--input-error',
    errorAttributes: [],
    showHelp: false,
    helpClass: 'contacts-contacts__contact_relation2_category-id--input-help',
    helpAttributes: [],
    help: 'activities.activity.contact_relation2_category_id.help',
    showFeedback: true,
    feedbackClass: 'contacts-contacts__contact_relation2_category-id--input-feedback',
    feedbackAttributes: [],
    feedback: 'activities.activity.contact_relation2_category_id.feedback',
    showLabel: true,
    labelClass: 'contacts-contacts__contact_relation2_category-id--input-label',
    labelAttributes: {
      for: 'contacts-contacts__contact_relation2_category-id',
    },
  },
  contact_relation2_category: {
    fieldPath: 'contact_relation2_category',
    errorFieldPath: 'contact_relation2_category',
    fieldReadPath: 'contact_relation2_category',
    name: 'contact_relation2_category',
    label: 'contacts.contact.contact_relation2_category.label',
    id: 'contacts-contacts__contact_relation2_category',
    veeValidation: true,
    rules: ['nullable'],
    warningRules: [],
    fieldClass: 'contacts-contacts__contact_relation2_category--input',
    showError: true,
    errorClass: 'contacts-contacts__contact_relation2_category--input-error',
    errorAttributes: [],
    showHelp: false,
    helpClass: 'contacts-contacts__contact_relation2_category--input-help',
    helpAttributes: [],
    help: 'activities.activity.contact_relation2_category.help',
    showFeedback: true,
    feedbackClass: 'contacts-contacts__contact_relation2_category--input-feedback',
    feedbackAttributes: [],
    feedback: 'activities.activity.contact_relation2_category.feedback',
    showLabel: true,
    labelClass: 'activities-contact_relation2_category--input-label',
    labelAttributes: {
      for: 'contacts-contacts__contact_relation2_category',
    },
    selectLabel: 'name',
    selectEntity: 'contact-relation-category',
    selectMultiple: false,
    withTableSearch: false,
    withNew: false,
    filters: [
      {
        filterField: 'type',
        modelField: null,
        value: ['individual'],
      },
      {
        filterField: 'status',
        modelField: null,
        value: ['active'],
      },
    ],
  },
  relation2_firstname: {
    fieldPath: 'relation2_firstname',
    errorFieldPath: 'relation2_firstname',
    fieldReadPath: 'relation2_firstname',
    name: 'relation2_firstname',
    label: 'contacts.contacts.contact_individual.firstname.label',
    id: 'contacts-contacts__relation2-firstname',
    veeValidation: true,
    rules: ['required', 'string'],
    warningRules: [],
    fieldClass: 'contacts-contacts__relation2-firstname--input',
    showError: true,
    errorClass: 'contacts-contacts__relation2-firstname--input-error',
    errorAttributes: [],
    showHelp: false,
    helpClass: 'contacts-contacts__relation2-firstname--input-help',
    helpAttributes: [],
    help: 'contacts.contacts.relation2_firstname.help',
    showFeedback: true,
    feedbackClass: 'contacts-contacts__relation2-firstname--input-feedback',
    feedbackAttributes: [],
    feedback: 'contacts.contacts.relation2_firstname.feedback',
    showLabel: true,
    labelClass: 'contacts-contacts__relation2-firstname--input-label',
    labelAttributes: {
      for: 'contacts-contacts__relation2-firstname',
    },
  },
  relation2_lastname: {
    fieldPath: 'relation2_lastname',
    errorFieldPath: 'relation2_lastname',
    fieldReadPath: 'relation2_lastname',
    name: 'relation2_lastname',
    label: 'contacts.contacts.contact_individual.lastname.label',
    id: 'contacts-contacts__relation2-lastname',
    veeValidation: true,
    rules: ['required', 'string'],
    warningRules: [],
    fieldClass: 'contacts-contacts__relation2-lastname--input',
    showError: true,
    errorClass: 'contacts-contacts__relation2-lastname--input-error',
    errorAttributes: [],
    showHelp: false,
    helpClass: 'contacts-contacts__relation2-lastname--input-help',
    helpAttributes: [],
    help: 'contacts.contacts.relation2_lastname.help',
    showFeedback: true,
    feedbackClass: 'contacts-contacts__relation2-lastname--input-feedback',
    feedbackAttributes: [],
    feedback: 'contacts.contacts.relation2_lastname.feedback',
    showLabel: true,
    labelClass: 'contacts-contacts__relation2-lastname--input-label',
    labelAttributes: {
      for: 'contacts-contacts__relation2-lastname',
    },
  },
  relation2_birthdate: {
    fieldPath: 'relation2_birthdate',
    errorFieldPath: 'relation2_birthdate',
    fieldReadPath: 'relation2_birthdate',
    name: 'relation2_birthdate',
    label: 'contacts.contacts.contact_individual.birthdate.label',
    id: 'contacts-contacts__relation2-birthdate',
    veeValidation: true,
    rules: ['required_if_show_mandatory:show_new_contact_relation2_birthdate'],
    warningRules: [],
    fieldClass: 'contacts-contacts__relation2-birthdate--input',
    showError: true,
    errorClass: 'contacts-contacts__relation2-birthdate--input-error',
    errorAttributes: [],
    showHelp: false,
    helpClass: 'contacts-contacts__relation2-birthdate--input-help',
    helpAttributes: [],
    help: 'contacts.contacts.relation2_birthdate.help',
    showFeedback: true,
    feedbackClass: 'contacts-contacts__relation2-birthdate--input-feedback',
    feedbackAttributes: [],
    feedback: 'contacts.contacts.relation2_birthdate.feedback',
    showLabel: true,
    labelClass: 'contacts-contacts__relation2-birthdate--input-label',
    labelAttributes: {
      for: 'contacts-contacts__relation2-birthdate',
    },
  },
  relation2_gender: {
    fieldPath: 'relation2_gender',
    errorFieldPath: 'relation2_gender',
    fieldReadPath: 'relation2_gender',
    name: 'relation2_gender',
    label: 'contacts.contacts.contact_individual.gender.label',
    options: [
      {
        text: 'global.contact_individual.gender.placeholder',
        value: null,
      },
      {
        text: 'global.contact_individual.man',
        value: 'M',
      },
      {
        text: 'global.contact_individual.woman',
        value: 'W',
      },
      {
        text: 'global.contact_individual.na',
        value: '-',
      },
    ],
    id: 'contacts-contacts__relation2-gender',
    veeValidation: true,
    rules: ['required_if_show_mandatory:show_new_contact_relation2_gender'],
    warningRules: [],
    fieldClass: 'contacts-contacts__relation2-gender--input',
    showError: true,
    errorClass: 'contacts-contacts__relation2-gender--input-error',
    errorAttributes: [],
    showHelp: false,
    helpClass: 'contacts-contacts__relation2-gender--input-help',
    helpAttributes: [],
    help: 'contacts.contacts.relation2_gender.help',
    showFeedback: true,
    feedbackClass: 'contacts-contacts__relation2-gender--input-feedback',
    feedbackAttributes: [],
    feedback: 'contacts.contacts.relation2_gender.feedback',
    showLabel: true,
    labelClass: 'contacts-contacts__relation2-gender--input-label',
    labelAttributes: {
      for: 'contacts-contacts__relation2-gender',
    },
  },
  relation2_street: {
    fieldPath: 'relation2_street',
    errorFieldPath: 'relation2_street',
    fieldReadPath: 'relation2_street',
    name: 'relation2_street',
    label: 'contacts.contacts.contact_detail.street.label',
    id: 'contacts-contacts__relation2-street',
    veeValidation: true,
    rules: ['required_if_show_mandatory:show_new_contact_relation2_address_fields'],
    warningRules: [],
    fieldClass: 'contacts-contacts__relation2-street--input',
    showError: true,
    errorClass: 'contacts-contacts__relation2-street--input-error',
    errorAttributes: [],
    showHelp: false,
    helpClass: 'contacts-contacts__relation2-street--input-help',
    helpAttributes: [],
    help: 'contacts.contacts.relation2_street.help',
    showFeedback: true,
    feedbackClass: 'contacts-contacts__relation2-street--input-feedback',
    feedbackAttributes: [],
    feedback: 'contacts.contacts.relation2_street.feedback',
    showLabel: true,
    labelClass: 'contacts-contacts__relation2-street--input-label',
    labelAttributes: {
      for: 'contacts-contacts__relation2-street',
    },
    placeholder: 'contacts.contacts.contact_detail.street.label',
  },
  relation2_street2: {
    fieldPath: 'relation2_street2',
    errorFieldPath: 'relation2_street2',
    fieldReadPath: 'relation2_street2',
    name: 'relation2_street2',
    label: 'ㅤ',
    id: 'contacts-contacts__relation2-street2',
    veeValidation: true,
    rules: ['nullable'],
    warningRules: [],
    fieldClass: 'contacts-contacts__relation2-street2--input',
    showError: true,
    errorClass: 'contacts-contacts__relation2-street2--input-error',
    errorAttributes: [],
    showHelp: false,
    helpClass: 'contacts-contacts__relation2-street2--input-help',
    helpAttributes: [],
    help: 'contacts.contacts.relation2_street2.help',
    showFeedback: true,
    feedbackClass: 'contacts-contacts__relation2-street2--input-feedback',
    feedbackAttributes: [],
    feedback: 'contacts.contacts.relation2_street2.feedback',
    showLabel: true,
    labelClass: 'contacts-contacts__relation2-street2--input-label',
    labelAttributes: {
      for: 'contacts-contacts__relation2-street2',
    },
    placeholder: 'contacts.contacts.contact_detail.street2.label',
  },
  relation2_zip: {
    fieldPath: 'relation2_zip',
    errorFieldPath: 'relation2_zip',
    fieldReadPath: 'relation2_zip',
    name: 'relation2_zip',
    label: '',
    id: 'contacts-contacts__relation2-zip',
    veeValidation: true,
    rules: ['required_if_show_mandatory:show_new_contact_relation2_address_fields'],
    warningRules: [],
    fieldClass: 'contacts-contacts__relation2-zip--input',
    showError: true,
    errorClass: 'contacts-contacts__relation2-zip--input-error',
    errorAttributes: [],
    showHelp: false,
    helpClass: 'contacts-contacts__relation2-zip--input-help',
    helpAttributes: [],
    help: 'contacts.contacts.relation2_zip.help',
    showFeedback: true,
    feedbackClass: 'contacts-contacts__relation2-zip--input-feedback',
    feedbackAttributes: [],
    feedback: 'contacts.contacts.relation2_zip.feedback',
    showLabel: true,
    labelClass: 'contacts-contacts__relation2-zip--input-label',
    labelAttributes: {
      for: 'contacts-contacts__relation2-zip',
    },
    placeholder: 'contacts.contacts.contact_detail.zip.label',
  },
  relation2_city: {
    fieldPath: 'relation2_city',
    errorFieldPath: 'relation2_city',
    fieldReadPath: 'relation2_city',
    name: 'relation2_city',
    label: '',
    id: 'contacts-contacts__relation2-city',
    veeValidation: true,
    rules: ['required_if_show_mandatory:show_new_contact_relation2_address_fields'],
    warningRules: [],
    fieldClass: 'contacts-contacts__relation2-city--input',
    showError: true,
    errorClass: 'contacts-contacts__relation2-city--input-error',
    errorAttributes: [],
    showHelp: false,
    helpClass: 'contacts-contacts__relation2-city--input-help',
    helpAttributes: [],
    help: 'contacts.contacts.relation2_city.help',
    showFeedback: true,
    feedbackClass: 'contacts-contacts__relation2-city--input-feedback',
    feedbackAttributes: [],
    feedback: 'contacts.contacts.relation2_city.feedback',
    showLabel: true,
    labelClass: 'contacts-contacts__relation2-city--input-label',
    labelAttributes: {
      for: 'contacts-contacts__relation2-city',
    },
    placeholder: 'contacts.contacts.contact_detail.city.label',
  },
  relation2_country: {
    fieldPath: 'relation2_country',
    errorFieldPath: 'relation2_country',
    fieldReadPath: 'relation2_country',
    name: 'relation2_country',
    label: '',
    options: [
      {
        text: 'countries.placeholder',
        value: 'null',
      },
      {
        text: 'countries.ad',
        value: 'ad',
      },
      {
        text: 'countries.ae',
        value: 'ae',
      },
      {
        text: 'countries.af',
        value: 'af',
      },
      {
        text: 'countries.ag',
        value: 'ag',
      },
      {
        text: 'countries.ai',
        value: 'ai',
      },
      {
        text: 'countries.al',
        value: 'al',
      },
      {
        text: 'countries.am',
        value: 'am',
      },
      {
        text: 'countries.ao',
        value: 'ao',
      },
      {
        text: 'countries.aq',
        value: 'aq',
      },
      {
        text: 'countries.ar',
        value: 'ar',
      },
      {
        text: 'countries.as',
        value: 'as',
      },
      {
        text: 'countries.at',
        value: 'at',
      },
      {
        text: 'countries.au',
        value: 'au',
      },
      {
        text: 'countries.aw',
        value: 'aw',
      },
      {
        text: 'countries.ax',
        value: 'ax',
      },
      {
        text: 'countries.az',
        value: 'az',
      },
      {
        text: 'countries.ba',
        value: 'ba',
      },
      {
        text: 'countries.bb',
        value: 'bb',
      },
      {
        text: 'countries.bd',
        value: 'bd',
      },
      {
        text: 'countries.be',
        value: 'be',
      },
      {
        text: 'countries.bf',
        value: 'bf',
      },
      {
        text: 'countries.bg',
        value: 'bg',
      },
      {
        text: 'countries.bh',
        value: 'bh',
      },
      {
        text: 'countries.bi',
        value: 'bi',
      },
      {
        text: 'countries.bj',
        value: 'bj',
      },
      {
        text: 'countries.bl',
        value: 'bl',
      },
      {
        text: 'countries.bm',
        value: 'bm',
      },
      {
        text: 'countries.bn',
        value: 'bn',
      },
      {
        text: 'countries.bo',
        value: 'bo',
      },
      {
        text: 'countries.bq',
        value: 'bq',
      },
      {
        text: 'countries.br',
        value: 'br',
      },
      {
        text: 'countries.bs',
        value: 'bs',
      },
      {
        text: 'countries.bt',
        value: 'bt',
      },
      {
        text: 'countries.bv',
        value: 'bv',
      },
      {
        text: 'countries.bw',
        value: 'bw',
      },
      {
        text: 'countries.by',
        value: 'by',
      },
      {
        text: 'countries.bz',
        value: 'bz',
      },
      {
        text: 'countries.ca',
        value: 'ca',
      },
      {
        text: 'countries.cc',
        value: 'cc',
      },
      {
        text: 'countries.cd',
        value: 'cd',
      },
      {
        text: 'countries.cf',
        value: 'cf',
      },
      {
        text: 'countries.cg',
        value: 'cg',
      },
      {
        text: 'countries.ch',
        value: 'ch',
      },
      {
        text: 'countries.ci',
        value: 'ci',
      },
      {
        text: 'countries.ck',
        value: 'ck',
      },
      {
        text: 'countries.cl',
        value: 'cl',
      },
      {
        text: 'countries.cm',
        value: 'cm',
      },
      {
        text: 'countries.cn',
        value: 'cn',
      },
      {
        text: 'countries.co',
        value: 'co',
      },
      {
        text: 'countries.cr',
        value: 'cr',
      },
      {
        text: 'countries.cu',
        value: 'cu',
      },
      {
        text: 'countries.cv',
        value: 'cv',
      },
      {
        text: 'countries.cw',
        value: 'cw',
      },
      {
        text: 'countries.cx',
        value: 'cx',
      },
      {
        text: 'countries.cy',
        value: 'cy',
      },
      {
        text: 'countries.cz',
        value: 'cz',
      },
      {
        text: 'countries.de',
        value: 'de',
      },
      {
        text: 'countries.dj',
        value: 'dj',
      },
      {
        text: 'countries.dk',
        value: 'dk',
      },
      {
        text: 'countries.dm',
        value: 'dm',
      },
      {
        text: 'countries.do',
        value: 'do',
      },
      {
        text: 'countries.dz',
        value: 'dz',
      },
      {
        text: 'countries.ec',
        value: 'ec',
      },
      {
        text: 'countries.ee',
        value: 'ee',
      },
      {
        text: 'countries.eg',
        value: 'eg',
      },
      {
        text: 'countries.eh',
        value: 'eh',
      },
      {
        text: 'countries.er',
        value: 'er',
      },
      {
        text: 'countries.es',
        value: 'es',
      },
      {
        text: 'countries.et',
        value: 'et',
      },
      {
        text: 'countries.fi',
        value: 'fi',
      },
      {
        text: 'countries.fj',
        value: 'fj',
      },
      {
        text: 'countries.fk',
        value: 'fk',
      },
      {
        text: 'countries.fm',
        value: 'fm',
      },
      {
        text: 'countries.fo',
        value: 'fo',
      },
      {
        text: 'countries.fr',
        value: 'fr',
      },
      {
        text: 'countries.ga',
        value: 'ga',
      },
      {
        text: 'countries.gb',
        value: 'gb',
      },
      {
        text: 'countries.gd',
        value: 'gd',
      },
      {
        text: 'countries.ge',
        value: 'ge',
      },
      {
        text: 'countries.gf',
        value: 'gf',
      },
      {
        text: 'countries.gg',
        value: 'gg',
      },
      {
        text: 'countries.gh',
        value: 'gh',
      },
      {
        text: 'countries.gi',
        value: 'gi',
      },
      {
        text: 'countries.gl',
        value: 'gl',
      },
      {
        text: 'countries.gm',
        value: 'gm',
      },
      {
        text: 'countries.gn',
        value: 'gn',
      },
      {
        text: 'countries.gp',
        value: 'gp',
      },
      {
        text: 'countries.gq',
        value: 'gq',
      },
      {
        text: 'countries.gr',
        value: 'gr',
      },
      {
        text: 'countries.gs',
        value: 'gs',
      },
      {
        text: 'countries.gt',
        value: 'gt',
      },
      {
        text: 'countries.gu',
        value: 'gu',
      },
      {
        text: 'countries.gw',
        value: 'gw',
      },
      {
        text: 'countries.gy',
        value: 'gy',
      },
      {
        text: 'countries.hk',
        value: 'hk',
      },
      {
        text: 'countries.hm',
        value: 'hm',
      },
      {
        text: 'countries.hn',
        value: 'hn',
      },
      {
        text: 'countries.hr',
        value: 'hr',
      },
      {
        text: 'countries.ht',
        value: 'ht',
      },
      {
        text: 'countries.hu',
        value: 'hu',
      },
      {
        text: 'countries.id',
        value: 'id',
      },
      {
        text: 'countries.ie',
        value: 'ie',
      },
      {
        text: 'countries.il',
        value: 'il',
      },
      {
        text: 'countries.im',
        value: 'im',
      },
      {
        text: 'countries.in',
        value: 'in',
      },
      {
        text: 'countries.io',
        value: 'io',
      },
      {
        text: 'countries.iq',
        value: 'iq',
      },
      {
        text: 'countries.ir',
        value: 'ir',
      },
      {
        text: 'countries.is',
        value: 'is',
      },
      {
        text: 'countries.it',
        value: 'it',
      },
      {
        text: 'countries.je',
        value: 'je',
      },
      {
        text: 'countries.jm',
        value: 'jm',
      },
      {
        text: 'countries.jo',
        value: 'jo',
      },
      {
        text: 'countries.jp',
        value: 'jp',
      },
      {
        text: 'countries.ke',
        value: 'ke',
      },
      {
        text: 'countries.kg',
        value: 'kg',
      },
      {
        text: 'countries.kh',
        value: 'kh',
      },
      {
        text: 'countries.ki',
        value: 'ki',
      },
      {
        text: 'countries.km',
        value: 'km',
      },
      {
        text: 'countries.kn',
        value: 'kn',
      },
      {
        text: 'countries.kp',
        value: 'kp',
      },
      {
        text: 'countries.kr',
        value: 'kr',
      },
      {
        text: 'countries.kw',
        value: 'kw',
      },
      {
        text: 'countries.ky',
        value: 'ky',
      },
      {
        text: 'countries.kz',
        value: 'kz',
      },
      {
        text: 'countries.la',
        value: 'la',
      },
      {
        text: 'countries.lb',
        value: 'lb',
      },
      {
        text: 'countries.lc',
        value: 'lc',
      },
      {
        text: 'countries.li',
        value: 'li',
      },
      {
        text: 'countries.lk',
        value: 'lk',
      },
      {
        text: 'countries.lr',
        value: 'lr',
      },
      {
        text: 'countries.ls',
        value: 'ls',
      },
      {
        text: 'countries.lt',
        value: 'lt',
      },
      {
        text: 'countries.lu',
        value: 'lu',
      },
      {
        text: 'countries.lv',
        value: 'lv',
      },
      {
        text: 'countries.ly',
        value: 'ly',
      },
      {
        text: 'countries.ma',
        value: 'ma',
      },
      {
        text: 'countries.mc',
        value: 'mc',
      },
      {
        text: 'countries.md',
        value: 'md',
      },
      {
        text: 'countries.me',
        value: 'me',
      },
      {
        text: 'countries.mf',
        value: 'mf',
      },
      {
        text: 'countries.mg',
        value: 'mg',
      },
      {
        text: 'countries.mh',
        value: 'mh',
      },
      {
        text: 'countries.mk',
        value: 'mk',
      },
      {
        text: 'countries.ml',
        value: 'ml',
      },
      {
        text: 'countries.mm',
        value: 'mm',
      },
      {
        text: 'countries.mn',
        value: 'mn',
      },
      {
        text: 'countries.mo',
        value: 'mo',
      },
      {
        text: 'countries.mp',
        value: 'mp',
      },
      {
        text: 'countries.mq',
        value: 'mq',
      },
      {
        text: 'countries.mr',
        value: 'mr',
      },
      {
        text: 'countries.ms',
        value: 'ms',
      },
      {
        text: 'countries.mt',
        value: 'mt',
      },
      {
        text: 'countries.mu',
        value: 'mu',
      },
      {
        text: 'countries.mv',
        value: 'mv',
      },
      {
        text: 'countries.mw',
        value: 'mw',
      },
      {
        text: 'countries.mx',
        value: 'mx',
      },
      {
        text: 'countries.my',
        value: 'my',
      },
      {
        text: 'countries.mz',
        value: 'mz',
      },
      {
        text: 'countries.na',
        value: 'na',
      },
      {
        text: 'countries.nc',
        value: 'nc',
      },
      {
        text: 'countries.ne',
        value: 'ne',
      },
      {
        text: 'countries.nf',
        value: 'nf',
      },
      {
        text: 'countries.ng',
        value: 'ng',
      },
      {
        text: 'countries.ni',
        value: 'ni',
      },
      {
        text: 'countries.nl',
        value: 'nl',
      },
      {
        text: 'countries.no',
        value: 'no',
      },
      {
        text: 'countries.np',
        value: 'np',
      },
      {
        text: 'countries.nr',
        value: 'nr',
      },
      {
        text: 'countries.nu',
        value: 'nu',
      },
      {
        text: 'countries.nz',
        value: 'nz',
      },
      {
        text: 'countries.om',
        value: 'om',
      },
      {
        text: 'countries.pa',
        value: 'pa',
      },
      {
        text: 'countries.pe',
        value: 'pe',
      },
      {
        text: 'countries.pf',
        value: 'pf',
      },
      {
        text: 'countries.pg',
        value: 'pg',
      },
      {
        text: 'countries.ph',
        value: 'ph',
      },
      {
        text: 'countries.pk',
        value: 'pk',
      },
      {
        text: 'countries.pl',
        value: 'pl',
      },
      {
        text: 'countries.pm',
        value: 'pm',
      },
      {
        text: 'countries.pn',
        value: 'pn',
      },
      {
        text: 'countries.pr',
        value: 'pr',
      },
      {
        text: 'countries.ps',
        value: 'ps',
      },
      {
        text: 'countries.pt',
        value: 'pt',
      },
      {
        text: 'countries.pw',
        value: 'pw',
      },
      {
        text: 'countries.py',
        value: 'py',
      },
      {
        text: 'countries.qa',
        value: 'qa',
      },
      {
        text: 'countries.re',
        value: 're',
      },
      {
        text: 'countries.ro',
        value: 'ro',
      },
      {
        text: 'countries.rs',
        value: 'rs',
      },
      {
        text: 'countries.ru',
        value: 'ru',
      },
      {
        text: 'countries.rw',
        value: 'rw',
      },
      {
        text: 'countries.sa',
        value: 'sa',
      },
      {
        text: 'countries.sb',
        value: 'sb',
      },
      {
        text: 'countries.sc',
        value: 'sc',
      },
      {
        text: 'countries.sd',
        value: 'sd',
      },
      {
        text: 'countries.se',
        value: 'se',
      },
      {
        text: 'countries.sg',
        value: 'sg',
      },
      {
        text: 'countries.sh',
        value: 'sh',
      },
      {
        text: 'countries.si',
        value: 'si',
      },
      {
        text: 'countries.sj',
        value: 'sj',
      },
      {
        text: 'countries.sk',
        value: 'sk',
      },
      {
        text: 'countries.sl',
        value: 'sl',
      },
      {
        text: 'countries.sm',
        value: 'sm',
      },
      {
        text: 'countries.sn',
        value: 'sn',
      },
      {
        text: 'countries.so',
        value: 'so',
      },
      {
        text: 'countries.sr',
        value: 'sr',
      },
      {
        text: 'countries.ss',
        value: 'ss',
      },
      {
        text: 'countries.st',
        value: 'st',
      },
      {
        text: 'countries.sv',
        value: 'sv',
      },
      {
        text: 'countries.sx',
        value: 'sx',
      },
      {
        text: 'countries.sy',
        value: 'sy',
      },
      {
        text: 'countries.sz',
        value: 'sz',
      },
      {
        text: 'countries.tc',
        value: 'tc',
      },
      {
        text: 'countries.td',
        value: 'td',
      },
      {
        text: 'countries.tf',
        value: 'tf',
      },
      {
        text: 'countries.tg',
        value: 'tg',
      },
      {
        text: 'countries.th',
        value: 'th',
      },
      {
        text: 'countries.tj',
        value: 'tj',
      },
      {
        text: 'countries.tk',
        value: 'tk',
      },
      {
        text: 'countries.tl',
        value: 'tl',
      },
      {
        text: 'countries.tm',
        value: 'tm',
      },
      {
        text: 'countries.tn',
        value: 'tn',
      },
      {
        text: 'countries.to',
        value: 'to',
      },
      {
        text: 'countries.tr',
        value: 'tr',
      },
      {
        text: 'countries.tt',
        value: 'tt',
      },
      {
        text: 'countries.tv',
        value: 'tv',
      },
      {
        text: 'countries.tw',
        value: 'tw',
      },
      {
        text: 'countries.tz',
        value: 'tz',
      },
      {
        text: 'countries.ua',
        value: 'ua',
      },
      {
        text: 'countries.ug',
        value: 'ug',
      },
      {
        text: 'countries.um',
        value: 'um',
      },
      {
        text: 'countries.us',
        value: 'us',
      },
      {
        text: 'countries.uy',
        value: 'uy',
      },
      {
        text: 'countries.uz',
        value: 'uz',
      },
      {
        text: 'countries.va',
        value: 'va',
      },
      {
        text: 'countries.vc',
        value: 'vc',
      },
      {
        text: 'countries.ve',
        value: 've',
      },
      {
        text: 'countries.vg',
        value: 'vg',
      },
      {
        text: 'countries.vi',
        value: 'vi',
      },
      {
        text: 'countries.vn',
        value: 'vn',
      },
      {
        text: 'countries.vu',
        value: 'vu',
      },
      {
        text: 'countries.wf',
        value: 'wf',
      },
      {
        text: 'countries.ws',
        value: 'ws',
      },
      {
        text: 'countries.xk',
        value: 'xk',
      },
      {
        text: 'countries.ye',
        value: 'ye',
      },
      {
        text: 'countries.yt',
        value: 'yt',
      },
      {
        text: 'countries.za',
        value: 'za',
      },
      {
        text: 'countries.zm',
        value: 'zm',
      },
      {
        text: 'countries.zw',
        value: 'zw',
      },
      {
        text: 'countries.other',
        value: 'other',
      },
    ],
    id: 'contacts-contacts__relation2-country',
    veeValidation: true,
    rules: ['required_if_show_mandatory:show_new_contact_relation2_address_fields'],
    warningRules: [],
    fieldClass: 'contacts-contacts__relation2-country--input',
    showError: true,
    errorClass: 'contacts-contacts__relation2-country--input-error',
    errorAttributes: [],
    showHelp: false,
    helpClass: 'contacts-contacts__relation2-country--input-help',
    helpAttributes: [],
    help: 'contacts.contacts.relation2_country.help',
    showFeedback: true,
    feedbackClass: 'contacts-contacts__relation2-country--input-feedback',
    feedbackAttributes: [],
    feedback: 'contacts.contacts.relation2_country.feedback',
    showLabel: true,
    labelClass: 'contacts-contacts__relation2-country--input-label',
    labelAttributes: {
      for: 'contacts-contacts__relation2-country',
    },
  },
  relation2_phone: {
    fieldPath: 'relation2_phone',
    errorFieldPath: 'relation2_phone',
    fieldReadPath: 'relation2_phone',
    name: 'relation2_phone',
    label: 'contacts.contacts.contact_detail.phone1.label',
    id: 'contacts-contacts__relation2-phone',
    veeValidation: true,
    rules: ['required_if_show_mandatory:show_new_contact_relation2_phone1'],
    warningRules: [],
    fieldClass: 'contacts-contacts__relation2-phone--input',
    showError: true,
    errorClass: 'contacts-contacts__relation2-phone--input-error',
    errorAttributes: [],
    showHelp: false,
    helpClass: 'contacts-contacts__relation2-phone--input-help',
    helpAttributes: [],
    help: 'contacts.contacts.relation2_phone.help',
    showFeedback: true,
    feedbackClass: 'contacts-contacts__relation2-phone--input-feedback',
    feedbackAttributes: [],
    feedback: 'contacts.contacts.relation2_phone.feedback',
    showLabel: true,
    labelClass: 'contacts-contacts__relation2-phone--input-label',
    labelAttributes: {
      for: 'contacts-contacts__relation2-phone',
    },
  },
  relation2_phone2: {
    fieldPath: 'relation2_phone2',
    errorFieldPath: 'relation2_phone2',
    fieldReadPath: 'relation2_phone2',
    name: 'relation2_phone2',
    label: 'contacts.contacts.contact_detail.phone2.label',
    id: 'contacts-contacts__relation2-phone2',
    veeValidation: true,
    rules: ['required_if_show_mandatory:show_new_contact_relation2_phone2'],
    warningRules: [],
    fieldClass: 'contacts-contacts__relation2-phone2--input',
    showError: true,
    errorClass: 'contacts-contacts__relation2-phone2--input-error',
    errorAttributes: [],
    showHelp: false,
    helpClass: 'contacts-contacts__relation2-phone2--input-help',
    helpAttributes: [],
    help: 'contacts.contacts.relation2_phone2.help',
    showFeedback: true,
    feedbackClass: 'contacts-contacts__relation2-phone2--input-feedback',
    feedbackAttributes: [],
    feedback: 'contacts.contacts.relation2_phone2.feedback',
    showLabel: true,
    labelClass: 'contacts-contacts__relation2-phone2--input-label',
    labelAttributes: {
      for: 'contacts-contacts__relation2-phone2',
    },
  },
  relation2_email: {
    fieldPath: 'relation2_email',
    errorFieldPath: 'relation2_email',
    fieldReadPath: 'relation2_email',
    name: 'relation2_email',
    label: 'contacts.contacts.contact_detail.email1.label',
    id: 'contacts-contacts__relation2-email',
    veeValidation: true,
    rules: ['required_if_show_mandatory:show_new_contact_relation2_email1', 'email'],
    warningRules: [],
    fieldClass: 'contacts-contacts__relation2-email--input',
    showError: true,
    errorClass: 'contacts-contacts__relation2-email--input-error',
    errorAttributes: [],
    showHelp: false,
    helpClass: 'contacts-contacts__relation2-email--input-help',
    helpAttributes: [],
    help: 'contacts.contacts.relation2_email.help',
    showFeedback: true,
    feedbackClass: 'contacts-contacts__relation2-email--input-feedback',
    feedbackAttributes: [],
    feedback: 'contacts.contacts.relation2_email.feedback',
    showLabel: true,
    labelClass: 'contacts-contacts__relation2-email--input-label',
    labelAttributes: {
      for: 'contacts-contacts__relation2-email',
    },
  },
  relation2_email2: {
    fieldPath: 'relation2_email2',
    errorFieldPath: 'relation2_email2',
    fieldReadPath: 'relation2_email2',
    name: 'relation2_email2',
    label: 'contacts.contacts.contact_detail.email2.label',
    id: 'contacts-contacts__relation2-email2',
    veeValidation: true,
    rules: ['required_if_show_mandatory:show_new_contact_relation2_email2'],
    warningRules: [],
    fieldClass: 'contacts-contacts__relation2-email2--input',
    showError: true,
    errorClass: 'contacts-contacts__relation2-email2--input-error',
    errorAttributes: [],
    showHelp: false,
    helpClass: 'contacts-contacts__relation2-email2--input-help',
    helpAttributes: [],
    help: 'contacts.contacts.relation2_email2.help',
    showFeedback: true,
    feedbackClass: 'contacts-contacts__relation2-email2--input-feedback',
    feedbackAttributes: [],
    feedback: 'contacts.contacts.relation2_email2.feedback',
    showLabel: true,
    labelClass: 'contacts-contacts__relation2-email2--input-label',
    labelAttributes: {
      for: 'contacts-contacts__relation2-email2',
    },
  },
  relation2_id_card_number: {
    fieldPath: 'relation2_id_card_number',
    errorFieldPath: 'relation2_id_card_number',
    fieldReadPath: 'relation2_id_card_number',
    name: 'relation2_id_card_number',
    label: 'contacts.contacts.contact_individual.id_card_number.label',
    id: 'contacts-contacts__relation2-id-card-number',
    veeValidation: true,
    rules: ['required_if_show_mandatory:show_new_contact_relation2_id_card_number'],
    warningRules: [],
    fieldClass: 'contacts-contacts__relation2-id-card-number--input',
    showError: true,
    errorClass: 'contacts-contacts__relation2-id-card-number--input-error',
    errorAttributes: [],
    showHelp: false,
    helpClass: 'contacts-contacts__relation2-id-card-number--input-help',
    helpAttributes: [],
    help: 'contacts.contacts.relation2_id_card_number.help',
    showFeedback: true,
    feedbackClass: 'contacts-contacts__relation2-id-card-number--input-feedback',
    feedbackAttributes: [],
    feedback: 'contacts.contacts.relation2_id_card_number.feedback',
    showLabel: true,
    labelClass: 'contacts-contacts__relation2-id-card-number--input-label',
    labelAttributes: {
      for: 'contacts-contacts__relation2-id-card-number',
    },
  },
  relation2_passport_number: {
    fieldPath: 'relation2_passport_number',
    errorFieldPath: 'relation2_passport_number',
    fieldReadPath: 'relation2_passport_number',
    name: 'relation2_passport_number',
    label: 'contacts.contacts.contact_individual.passport_number.label',
    id: 'contacts-contacts__relation2-passport-number',
    veeValidation: true,
    rules: ['required_if_show_mandatory:show_new_contact_relation2_passport_number'],
    warningRules: [],
    fieldClass: 'contacts-contacts__relation2-passport-number--input',
    showError: true,
    errorClass: 'contacts-contacts__relation2-passport-number--input-error',
    errorAttributes: [],
    showHelp: false,
    helpClass: 'contacts-contacts__relation2-passport-number--input-help',
    helpAttributes: [],
    help: 'contacts.contacts.relation2_passport_number.help',
    showFeedback: true,
    feedbackClass: 'contacts-contacts__relation2-passport-number--input-feedback',
    feedbackAttributes: [],
    feedback: 'contacts.contacts.relation2_passport_number.feedback',
    showLabel: true,
    labelClass: 'contacts-contacts__relation2-passport-number--input-label',
    labelAttributes: {
      for: 'contacts-contacts__relation2-passport-number',
    },
  },
  relation2_registration_number: {
    fieldPath: 'relation2_registration_number',
    errorFieldPath: 'relation2_registration_number',
    fieldReadPath: 'relation2_registration_number',
    name: 'relation2_registration_number',
    label: 'contacts.contacts.contact_individual.registration_number.label',
    id: 'contacts-contacts__relation2-registration-number',
    veeValidation: true,
    rules: ['required_if_show_mandatory:show_new_contact_relation2_registration_number'],
    warningRules: [],
    fieldClass: 'contacts-contacts__relation2-registration-number--input',
    showError: true,
    errorClass: 'contacts-contacts__relation2-registration-number--input-error',
    errorAttributes: [],
    showHelp: false,
    helpClass: 'contacts-contacts__relation2-registration-number--input-help',
    helpAttributes: [],
    help: 'contacts.contacts.relation2_registration_number.help',
    showFeedback: true,
    feedbackClass: 'contacts-contacts__relation2-registration-number--input-feedback',
    feedbackAttributes: [],
    feedback: 'contacts.contacts.relation2_registration_number.feedback',
    showLabel: true,
    labelClass: 'contacts-contacts__relation2-registration-number--input-label',
    labelAttributes: {
      for: 'contacts-contacts__relation2-registration-number',
    },
  },
  relation2_external_reference: {
    fieldPath: 'relation2_external_reference',
    errorFieldPath: 'relation2_external_reference',
    fieldReadPath: 'relation2_external_reference',
    name: 'relation2_external_reference',
    label: 'contacts.contacts.external_reference.label',
    id: 'contacts-contacts__relation2-external-reference',
    veeValidation: true,
    rules: ['required_if_show_mandatory:show_new_contact_relation2_external_reference'],
    warningRules: [],
    fieldClass: 'contacts-contacts__relation2-external-reference--input',
    showError: true,
    errorClass: 'contacts-contacts__relation2-external-reference--input-error',
    errorAttributes: [],
    showHelp: false,
    helpClass: 'contacts-contacts__relation2-external-reference--input-help',
    helpAttributes: [],
    help: 'contacts.contacts.relation2_external_reference.help',
    showFeedback: true,
    feedbackClass: 'contacts-contacts__relation2-external-reference--input-feedback',
    feedbackAttributes: [],
    feedback: 'contacts.contacts.relation2_external_reference.feedback',
    showLabel: true,
    labelClass: 'contacts-contacts__relation2-external-reference--input-label',
    labelAttributes: {
      for: 'contacts-contacts__relation2-external-reference',
    },
  },
  initial_agreement: {
    fieldPath: 'initial_agreement',
    errorFieldPath: 'initial_agreement',
    fieldReadPath: 'initial_agreement',
    name: 'initial_agreement',
    id: 'contacts-contacts__initial_agreement',
    veeValidation: true,
    rules: ['required', 'accepted'],
    warningRules: [],
    fieldClass: 'contacts-contacts__initial_agreement--input',
    showError: true,
    errorClass: 'contacts-contacts__initial_agreement--input-error',
    errorAttributes: [],
    showHelp: false,
    helpClass: 'contacts-contacts__initial_agreement--input-help',
    helpAttributes: [],
    help: 'contacts.contacts.initial_agreement.help',
    showFeedback: true,
    feedbackClass: 'contacts-contacts__initial_agreement--input-feedback',
    feedbackAttributes: [],
    feedback: 'contacts.contacts.initial_agreement.feedback',
    showLabel: false,
  },
};
